export const svgList = (props) => {
  return {
    Outlined1: {
      viewBox: '0 0 18 21',
      path: (
        <>
          <g clipPath="url(#clip0_940_84215)">
            <path
              d="M16.936 1.07886H0.865234V20.1408H16.936V1.07886Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '1.9'}
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'round'
              }
              strokeLinejoin="round"
            />
            <path
              d="M5.75344 4.48877H3.29102V6.9747H5.75344V4.48877Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'square'
              }
            />
            <path
              d="M5.75344 9.3667H3.29102V11.8526H5.75344V9.3667Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'square'
              }
            />
            <path
              d="M5.75344 14.2449H3.29102V16.7308H5.75344V14.2449Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'square'
              }
            />
            <path
              d="M8.40039 6.60986H14.4004"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'square'
              }
            />
            <path
              d="M8.40039 11.6099H14.4004"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'square'
              }
            />
            <path
              d="M8.40039 16.6099H14.4004"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'square'
              }
            />
          </g>
          <defs>
            <clipPath id="clip0_940_84215">
              <rect
                width="17"
                height="20"
                fill="white"
                transform="translate(0.400391 0.609863)"
              />
            </clipPath>
          </defs>
        </>
      ),
    },
    Outlined2: {
      viewBox: '0 0 21 16',
      path: (
        <>
          <g clipPath="url(#clip0_940_84370)">
            <path
              d="M6.42738 1.60474H14.9214C15.9227 1.60474 16.7433 2.40227 16.7433 3.39314V9.49142H4.60547V3.39314C4.60547 2.41032 5.41794 1.60474 6.42738 1.60474Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
              strokeMiterlimit="10"
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'round'
              }
            />
            <path
              d="M3.05343 8.22656C3.91515 8.22656 4.61273 8.91131 4.61273 9.75717V15.0015H1.49414V9.75717C1.49414 8.91131 2.19172 8.22656 3.05343 8.22656Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
              strokeMiterlimit="10"
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'round'
              }
            />
            <path
              d="M18.2933 8.22656C19.155 8.22656 19.8526 8.91131 19.8526 9.75717V15.0015H16.7422V9.75717C16.7422 8.91131 17.4398 8.22656 18.3015 8.22656H18.2933Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
              strokeMiterlimit="10"
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'round'
              }
            />
            <path
              d="M4.60547 14.9934H16.7433"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
              strokeMiterlimit="10"
              strokeLinecap={
                props.strokeLinecap ? props.strokeLinecap : 'round'
              }
            />
          </g>
          <defs>
            <clipPath id="clip0_940_84370">
              <rect
                width="20"
                height="15"
                fill="white"
                transform="translate(0.673828 0.799072)"
              />
            </clipPath>
          </defs>
        </>
      ),
    },
    Outlined3: {
      viewBox: '0 0 16 18',
      path: (
        <>
          <rect
            x="1.58203"
            y="1.78125"
            width="13"
            height="15"
            rx="2"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="5.32227"
            y1="0.78125"
            x2="5.32227"
            y2="17.7812"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M8.13867 2.2168V6.17686C8.13867 6.44413 8.46181 6.57798 8.6508 6.38899L10.0084 5.03136C10.1256 4.9142 10.3155 4.9142 10.4327 5.03136L11.7903 6.38899C11.9793 6.57798 12.3025 6.44413 12.3025 6.17686V2.2168"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
          />
        </>
      ),
    },
    Outlined4: {
      viewBox: '0 0 20 19',
      path: (
        <>
          <path
            d="M5.88068 17.1966H3.79727V15.1045L12.6629 6.23891L14.7547 8.33073L5.88068 17.1966ZM16.897 6.18896L14.8049 4.09686L16.5416 2.35994C16.5523 2.34929 16.5675 2.34929 16.5782 2.35994L18.6337 4.41551C18.6444 4.42616 18.6444 4.44139 18.6337 4.45204L18.6337 4.45207L16.897 6.18896Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
          />
          <line
            x1="4.40234"
            y1="1.97803"
            x2="4.40234"
            y2="7.53223"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="7.22852"
            y1="4.77319"
            x2="1.67432"
            y2="4.77319"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined5: {
      viewBox: '0 0 20 17',
      path: (
        <>
          <path
            d="M9.78952 2.66374V15.0973M9.78952 2.66374C8.67241 1.92155 7.15551 1.46533 5.48558 1.46533C3.81565 1.46533 2.29875 1.92155 1.18164 2.66374V15.0973C2.29875 14.3552 3.81565 13.8989 5.48558 13.8989C7.15551 13.8989 8.67241 14.3552 9.78952 15.0973M9.78952 2.66374C10.9066 1.92155 12.4235 1.46533 14.0935 1.46533C15.7643 1.46533 17.2803 1.92155 18.3974 2.66374V15.0973C17.2803 14.3552 15.7643 13.8989 14.0935 13.8989C12.4235 13.8989 10.9066 14.3552 9.78952 15.0973"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined6: {
      viewBox: '0 0 17 15',
      path: (
        <>
          <rect
            x="1.07227"
            y="1.44556"
            width="14.3235"
            height="12.3286"
            rx="2"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5'}
          />
          <path
            d="M15.3418 2.39185L9.53185 7.9422C8.75804 8.68144 7.53943 8.68055 6.76669 7.9402L0.975603 2.39185"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5'}
          />
        </>
      ),
    },
    Outlined7: {
      viewBox: '0 0 15 18',
      path: (
        <>
          <rect
            x="1.38477"
            y="6.94946"
            width="11.7331"
            height="9.82246"
            rx="2"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M4.63086 9.57861V4.06828C4.63086 2.62127 5.80389 1.44824 7.2509 1.44824V1.44824C8.69791 1.44824 9.87094 2.62127 9.87094 4.06828V9.57861"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined8: {
      viewBox: '0 0 19 19',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.69236 2.45219C6.49803 2.45219 5.35261 2.92664 4.50809 3.77116C3.66357 4.61568 3.18912 5.7611 3.18912 6.95543C3.18912 8.14977 3.66357 9.29519 4.50809 10.1397C5.35261 10.9842 6.49803 11.4587 7.69236 11.4587C8.8867 11.4587 10.0321 10.9842 10.8766 10.1397C11.7212 9.29519 12.1956 8.14977 12.1956 6.95543C12.1956 5.7611 11.7212 4.61568 10.8766 3.77116C10.0321 2.92664 8.8867 2.45219 7.69236 2.45219ZM0.9375 6.95543C0.937364 5.89233 1.18815 4.84421 1.66947 3.89632C2.15079 2.94842 2.84904 2.1275 3.70744 1.50035C4.56584 0.873189 5.56015 0.457493 6.6095 0.287069C7.65885 0.116645 8.73361 0.196304 9.74637 0.519568C10.7591 0.842833 11.6813 1.40057 12.4378 2.14743C13.1944 2.89429 13.764 3.80917 14.1003 4.81767C14.4366 5.82617 14.5302 6.89981 14.3733 7.95127C14.2164 9.00273 13.8136 10.0023 13.1976 10.8688L18.6206 16.2918C18.8257 16.5041 18.9392 16.7885 18.9366 17.0837C18.934 17.3789 18.8156 17.6612 18.6069 17.87C18.3982 18.0787 18.1158 18.1971 17.8206 18.1997C17.5254 18.2022 17.241 18.0888 17.0287 17.8837L11.6068 12.4618C10.5962 13.1804 9.40737 13.6069 8.17047 13.6947C6.93357 13.7824 5.69638 13.528 4.59447 12.9593C3.49256 12.3907 2.56845 11.5296 1.9234 10.4706C1.27835 9.41159 0.937259 8.19544 0.9375 6.95543Z"
            fill={props.stroke ? props.stroke : 'black'}
          />
        </>
      ),
    },
    Outlined9: {
      viewBox: '0 0 20 17',
      path: (
        <>
          <path
            d="M5.78906 4.58519L15.7296 1.60155V13.8117L5.78906 10.828V4.58519Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <mask id="path-2-inside-1_940_84059" fill="white">
            <rect
              x="0.255859"
              y="3.53906"
              width="6.71875"
              height="8.33526"
              rx="1"
            />
          </mask>
          <rect
            x="0.255859"
            y="3.53906"
            width="6.71875"
            height="8.33526"
            rx="1"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '4'}
            mask="url(#path-2-inside-1_940_84059)"
          />
          <line
            x1="3.46094"
            y1="11.4209"
            x2="3.46094"
            y2="15.7671"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M16.4844 9.97885C17.7393 9.97885 18.7566 8.96152 18.7566 7.70659C18.7566 6.45165 17.7393 5.43433 16.4844 5.43433"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined10: {
      viewBox: '0 0 17 19',
      path: (
        <>
          <rect
            x="1.51953"
            y="1.73291"
            width="14.3235"
            height="15.5586"
            rx="2"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="4.03125"
            y1="5.67529"
            x2="13.3315"
            y2="5.67529"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="4.03125"
            y1="9.69971"
            x2="13.3315"
            y2="9.69971"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="4.03125"
            y1="13.7241"
            x2="13.3315"
            y2="13.7241"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined11: {
      viewBox: '0 0 19 18',
      path: (
        <>
          <path
            d="M15.7539 7.95424V3.13428C15.7539 2.02971 14.8585 1.13428 13.7539 1.13428H3.39453C2.28996 1.13428 1.39453 2.02971 1.39453 3.13428V14.6846C1.39453 15.7891 2.28996 16.6846 3.39453 16.6846H8.04602"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="4.03125"
            y1="5.07471"
            x2="13.3315"
            y2="5.07471"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="4.03125"
            y1="13.1235"
            x2="8.93431"
            y2="13.1235"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="4.03125"
            y1="9.09912"
            x2="11.6793"
            y2="9.09912"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M9.25195 15.7276V17.1879C9.25195 17.3224 9.35763 17.428 9.49213 17.428H10.9524C11.0148 17.428 11.0773 17.404 11.1205 17.356L16.366 12.1154L14.5646 10.314L9.32401 15.5547C9.27597 15.6027 9.25195 15.6603 9.25195 15.7276ZM18.1583 10.3229C18.3456 10.1356 18.3456 9.83296 18.1583 9.64563L17.0342 8.52161C16.8469 8.33427 16.5443 8.33427 16.3569 8.52161L15.0786 9.80006L16.8799 11.6014L18.1583 10.3229Z"
            fill="white"
          />
        </>
      ),
    },
    Outlined12: {
      viewBox: '0 0 19 17',
      path: (
        <>
          <path
            d="M9.96799 14.9643L7.80469 15.2705L8.08301 12.8911L15.8127 4.3893C16.3314 3.8188 17.179 3.8188 17.6977 4.3893C18.2164 4.95979 18.2164 5.89207 17.6977 6.46256L9.96799 14.9643Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M14.9395 5.33643L16.8244 7.4236"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M8.66977 11.6941H1.67383"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M11.0974 6.51758H3.51953"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M12.9458 1.32788H1.67383"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined13: {
      viewBox: '0 0 15 15',
      path: (
        <>
          <path
            d="M11.1063 6.8768L12.6303 5.35278C13.4114 4.57173 13.4114 3.3054 12.6303 2.52435L12.1388 2.03287C11.3578 1.25182 10.0914 1.25182 9.3104 2.03287L6.30921 5.03405C5.52816 5.8151 5.52816 7.08143 6.30921 7.86248L6.42281 7.97608"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M3.58512 7.75796L2.0611 9.28199C1.28005 10.063 1.28005 11.3294 2.0611 12.1104L2.55258 12.6019C3.33363 13.3829 4.59996 13.3829 5.38101 12.6019L8.3822 9.60071C9.16325 8.81966 9.16325 7.55333 8.3822 6.77228L8.2686 6.65869"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined14: {
      viewBox: '0 0 16 18',
      path: (
        <>
          <path
            d="M12.2969 16.1099H3.29687C2.19231 16.1099 1.29688 15.2144 1.29688 14.1099V3.10986C1.29688 2.00529 2.19231 1.10986 3.29688 1.10986H10.1523C10.6468 1.10986 11.1238 1.29307 11.4912 1.62412L12.5572 2.58474L12.5591 2.58652L13.6437 3.57454C14.0598 3.95353 14.2969 4.49026 14.2969 5.05304V14.1099C14.2969 15.2144 13.4014 16.1099 12.2969 16.1099Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M8.86328 0.109863V4.71484C8.86328 5.81941 9.75871 6.71484 10.8633 6.71484H15.0488"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined15: {
      viewBox: '0 0 22 22',
      path: (
        <>
          <path
            d="M12.9375 20.8184H3.9375C2.83293 20.8184 1.9375 19.9229 1.9375 18.8184V7.81836C1.9375 6.71379 2.83293 5.81836 3.9375 5.81836H10.7929C11.2874 5.81836 11.7644 6.00157 12.1318 6.33261L13.1978 7.29324L13.1998 7.29501L14.2844 8.28303C14.7004 8.66202 14.9375 9.19876 14.9375 9.76153V18.8184C14.9375 19.9229 14.0421 20.8184 12.9375 20.8184Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M9.50391 4.81836V9.42334C9.50391 10.5279 10.3993 11.4233 11.5039 11.4233H15.6895"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M14.56 15.8584H18.0476C19.1521 15.8584 20.0476 14.963 20.0476 13.8584V5.63834C20.0476 5.07556 19.8105 4.53883 19.3944 4.15984L18.3331 3.19304L17.3057 2.26718C16.9383 1.93614 16.4613 1.75293 15.9668 1.75293H9.60156C8.49699 1.75293 7.60156 2.64836 7.60156 3.75293V6.47512"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M15.3105 1.20605V4.91064C15.3105 6.01521 16.206 6.91064 17.3105 6.91064H20.6529"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined16: {
      viewBox: '0 0 18 20',
      path: (
        <>
          <line
            x1="8.47813"
            y1="13.9347"
            x2="8.47813"
            y2="1.28543"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="14.7242"
            y1="7.50137"
            x2="2.07498"
            y2="7.50136"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined17: {
      viewBox: '0 0 17 19',
      path: (
        <>
          <path
            d="M15.181 4.75526L14.4103 15.5482C14.3784 15.9967 14.1777 16.4164 13.8486 16.7229C13.5196 17.0293 13.0866 17.1997 12.637 17.1997H5.28055C4.83089 17.1997 4.39794 17.0293 4.06889 16.7229C3.73984 16.4164 3.53914 15.9967 3.50721 15.5482L2.73655 4.75526M7.18099 8.31082V13.6442M10.7365 8.31082V13.6442M11.6254 4.75526V2.0886C11.6254 1.85285 11.5318 1.62676 11.3651 1.46006C11.1984 1.29336 10.9723 1.19971 10.7365 1.19971H7.18099C6.94524 1.19971 6.71915 1.29336 6.55245 1.46006C6.38575 1.62676 6.2921 1.85285 6.2921 2.0886V4.75526M1.84766 4.75526H16.0699"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.72'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined18: {
      viewBox: '0 0 22 17',
      path: (
        <>
          <path
            d="M16.4609 5.60379C16.4609 5.07229 16.2795 4.56255 15.9564 4.18672C15.6334 3.81089 15.1953 3.59975 14.7385 3.59975H9.57117L7.84874 1.5957H2.68142C2.2246 1.5957 1.78649 1.80684 1.46347 2.18267C1.14045 2.55851 0.958984 3.06824 0.958984 3.59975V13.62C0.958984 14.1515 1.14045 14.6612 1.46347 15.0371C1.78649 15.4129 2.2246 15.624 2.68142 15.624H14.7385C15.1953 15.624 15.6334 15.4129 15.9564 15.0371C16.2795 14.6612 16.4609 14.1515 16.4609 13.62"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.72244'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M15.793 9.63314L20.9603 9.63314M20.9603 9.63314L18.3766 12.2168M20.9603 9.63314L18.3766 7.04948"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.72244'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined19: {
      viewBox: '0 0 19 20',
      path: (
        <>
          <path
            d="M7.64624 4.40356H3.0203C2.52955 4.40356 2.0589 4.59851 1.71188 4.94553C1.36487 5.29254 1.16992 5.76319 1.16992 6.25394V16.431C1.16992 16.9218 1.36487 17.3924 1.71188 17.7394C2.0589 18.0864 2.52955 18.2814 3.0203 18.2814H13.1974C13.6881 18.2814 14.1588 18.0864 14.5058 17.7394C14.8528 17.3924 15.0478 16.9218 15.0478 16.431V11.8051"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.85038'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M17.9806 2.92084L17.9807 2.92081C17.9902 2.91129 17.9902 2.89766 17.9807 2.88813L16.1415 1.04893C16.1319 1.03941 16.1183 1.0394 16.1088 1.0489L17.9806 2.92084ZM17.9806 2.92084L16.4267 4.47491L14.5548 2.60302L16.1088 1.04893L17.9806 2.92084ZM6.56997 14.3239H4.70584V12.4521L12.6383 4.51961L14.5099 6.39125L6.56997 14.3239Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.52106'}
          />
        </>
      ),
    },
    Outlined20: {
      viewBox: '0 0 23 18',
      path: (
        <>
          <path
            d="M3.71927 4.40694L10.6543 2.13202C10.6666 2.128 10.6732 2.12858 10.6773 2.12928C10.6831 2.13026 10.6911 2.13311 10.6993 2.13904C10.7074 2.14497 10.7126 2.15163 10.7154 2.15686C10.7173 2.16056 10.7199 2.16664 10.7199 2.17953V14.4186C10.7199 14.4315 10.7173 14.4376 10.7154 14.4413C10.7126 14.4465 10.7074 14.4532 10.6993 14.4591C10.6911 14.465 10.6831 14.4679 10.6773 14.4689C10.6732 14.4696 10.6666 14.4701 10.6543 14.4661L3.71927 12.1912C2.46676 11.7803 1.61992 10.6113 1.61992 9.29315V7.305C1.61992 5.98682 2.46675 4.8178 3.71927 4.40694Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.9'}
          />
          <path
            d="M11.6699 10.4569C12.9249 10.4569 13.9422 9.43955 13.9422 8.18461C13.9422 6.92968 12.9249 5.91235 11.6699 5.91235"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.9'}
          />
          <path
            d="M17.2051 11.8701C19.1577 9.91752 19.1577 6.75169 17.2051 4.79907"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.9'}
          />
          <path
            d="M19.6699 15.334C23.5359 11.4681 23.5359 5.20016 19.6699 1.33423"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.9'}
          />
        </>
      ),
    },
    Outlined21: {
      viewBox: '0 0 20 20',
      path: (
        <>
          <path
            d="M1.14844 4.32006C1.14844 2.92917 2.22912 1.79907 3.5592 1.79907H15.7585C17.0678 1.79907 18.1484 2.90744 18.1484 4.29833V12.8175C18.1484 14.1867 17.0885 15.295 15.7792 15.295H14.5739V18.0551C14.5739 18.7071 13.8049 19.0548 13.3685 18.5767L10.2096 15.2733H3.5592C2.24991 15.2733 1.16922 14.1649 1.16922 12.7741V4.27659L1.14844 4.32006Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M6.14844 6.79907H13.1484"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
            strokeLinejoin="round"
          />
          <path
            d="M6.14844 10.7991H10.1484"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined22: {
      viewBox: '0 0 20 17',
      path: (
        <>
          <rect
            x="1.05664"
            y="5.4165"
            width="17"
            height="10.2941"
            rx="2"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M5.05664 4.88721V4.88721C5.05664 3.23035 6.39979 1.88721 8.05664 1.88721H9.55664H11.0566C12.7135 1.88721 14.0566 3.23035 14.0566 4.88721V4.88721"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M1.05664 9.38721L8.59984 11.2159C9.06431 11.3285 9.54897 11.3285 10.0134 11.2159L17.5566 9.38721"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined23: {
      viewBox: '0 0 22 21',
      path: (
        <>
          <rect
            x="1.95508"
            y="1.19995"
            width="6.00024"
            height="6.00024"
            rx="1"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <rect
            x="1.95508"
            y="13.199"
            width="6.00024"
            height="6.00024"
            rx="1"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <rect
            x="14.1543"
            y="13.199"
            width="6.00024"
            height="6.00024"
            rx="1"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <rect
            x="14.1543"
            y="1.19995"
            width="6.00024"
            height="6.00024"
            rx="1"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M7.95508 4.80176H13.9553"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M7.95508 16.8008H13.9553"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M16.9551 13.1987L16.9551 7.19849"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M4.95508 13.1987L4.95508 7.19849"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined24: {
      viewBox: '0 0 19 20',
      path: (
        <>
          <path
            d="M1.18164 7.09375V18.7812H12.8691"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <rect
            x="5.18164"
            y="1.78125"
            width="12.75"
            height="12.75"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M8.18164 8.0585L10.358 10.235L14.8115 5.78125"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined25: {
      viewBox: '0 0 14 14',
      path: (
        <>
          <line
            x1="0.628906"
            y1="1.78125"
            x2="13.3392"
            y2="1.78125"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="0.628906"
            y1="12.7812"
            x2="7.32972"
            y2="12.7813"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="0.628906"
            y1="7.28125"
            x2="11.0812"
            y2="7.28125"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined26: {
      viewBox: '0 0 17 17',
      path: (
        <>
          <path
            d="M15.4004 11.5922V5.43221C15.4004 4.39256 14.9874 3.39549 14.2522 2.66035C13.5171 1.92521 12.52 1.51221 11.4804 1.51221H5.32039C4.28074 1.51221 3.28367 1.92521 2.54853 2.66035C1.81339 3.39549 1.40039 4.39256 1.40039 5.43221V11.5922C1.40039 12.6319 1.81339 13.6289 2.54853 14.3641C3.28367 15.0992 4.28074 15.5122 5.32039 15.5122H11.4804C12.52 15.5122 13.5171 15.0992 14.2522 14.3641C14.9874 13.6289 15.4004 12.6319 15.4004 11.5922Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
          />
          <circle cx="11.9004" cy="5.01221" r="0.875" fill="black" />
        </>
      ),
    },
    Outlined27: {
      viewBox: '0 0 18 17',
      path: (
        <>
          <path
            d="M10.4397 11.094V15.7811H7.07812V5.22196H10.2747V7.16055H10.3916C10.6253 6.51435 11.024 6.00794 11.5877 5.6413C12.1514 5.27008 12.8228 5.08447 13.6019 5.08447C14.3444 5.08447 14.9883 5.25175 15.5337 5.5863C16.0836 5.91628 16.5098 6.37915 16.8123 6.97494C17.1194 7.56614 17.2706 8.25816 17.266 9.05101V15.7811H13.9044V11.0459C13.909 10.4592 13.7601 10.001 13.4576 9.67098C13.1597 9.34101 12.7449 9.17602 12.2133 9.17602C11.8604 9.17602 11.5488 9.25393 11.2784 9.40975C11.0126 9.56099 10.8063 9.77868 10.6597 10.0628C10.5176 10.347 10.4443 10.6907 10.4397 11.094Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.3'}
          />
          <path
            d="M1.53516 15.7808V5.22168H4.89674V15.7808H1.53516Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.3'}
          />
          <circle
            cx="2.9414"
            cy="2.18774"
            r="1.40625"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.3'}
          />
        </>
      ),
    },
    Outlined28: {
      viewBox: '0 0 23 14',
      path: (
        <>
          <path
            d="M12.6421 7.36349L15.2497 12.6889L22.2832 2.94897"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2.1'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M1.64213 7.36349L4.24966 12.6889L11.2832 2.94897"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2.1'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined29: {
      viewBox: '0 0 23 19',
      path: (
        <>
          <path
            d="M10.9246 14.814H3.41149C2.91334 14.814 2.43559 14.6161 2.08334 14.2639C1.73109 13.9116 1.5332 13.4339 1.5332 12.9357V3.5443C1.5332 3.04615 1.73109 2.5684 2.08334 2.21615C2.43559 1.86391 2.91334 1.66602 3.41149 1.66602H9.04635L10.9246 3.5443H16.5595C17.0576 3.5443 17.5354 3.74219 17.8876 4.09444C18.2399 4.44669 18.4378 4.92444 18.4378 5.42259V7.11842"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <line
            x1="17.8388"
            y1="17.9719"
            x2="17.8388"
            y2="10.8045"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="14.3057"
            y1="14.3376"
            x2="21.473"
            y2="14.3376"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined30: {
      viewBox: '0 0 19 20',
      path: (
        <>
          <path
            d="M8.53102 8.532C10.4585 8.532 12.021 6.96948 12.021 5.042C12.021 3.11453 10.4585 1.552 8.53102 1.552C6.60354 1.552 5.04102 3.11453 5.04102 5.042C5.04102 6.96948 6.60354 8.532 8.53102 8.532Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M5.12078 10.322C3.13078 11.492 1.80078 13.652 1.80078 16.122C5.85078 18.922 11.2108 18.922 15.2608 16.122C15.2608 13.652 13.9308 11.492 11.9408 10.322"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M14.7539 3.00391C15.8765 4.12655 15.8765 5.95909 14.7539 7.08174"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M17.1211 0.997803C19.3581 3.23483 19.3581 6.85865 17.1211 9.09568"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined31: {
      viewBox: '0 0 17 20',
      path: (
        <>
          <path
            d="M8.35573 8.6673C9.18322 8.6673 9.85404 8.01605 9.85404 7.21268C9.85404 6.40931 9.18322 5.75806 8.35573 5.75806C7.52824 5.75806 6.85742 6.40931 6.85742 7.21268C6.85742 8.01605 7.52824 8.6673 8.35573 8.6673Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.3'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M6.88822 9.85181C6.03388 10.3395 5.46289 11.2397 5.46289 12.2692C7.20162 13.4363 9.50274 13.4363 11.2415 12.2692C11.2415 11.2397 10.6705 10.3395 9.81614 9.85181"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.3'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M11.6345 16.8325L8.34877 18.7813L5.06309 16.8325C2.53996 15.3355 0.998047 12.6737 0.998047 9.7995V5.16165C2.92124 5.16165 4.47997 3.64837 4.47997 1.78125H12.212C12.212 3.64837 13.7707 5.16165 15.6939 5.16165V9.79406C15.6939 12.6682 14.152 15.3301 11.6288 16.827L11.6345 16.8325Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined32: {
      viewBox: '0 0 17 17',
      path: (
        <>
          <circle
            cx="8.67509"
            cy="8.51225"
            r="2.52665"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="8.92969"
            y1="3.25171"
            x2="8.92969"
            y2="1.31017"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="8.92969"
            y1="15.7144"
            x2="8.92969"
            y2="13.7728"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="13.9355"
            y1="8.53271"
            x2="15.8771"
            y2="8.53271"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="1.47266"
            y1="8.53271"
            x2="3.41419"
            y2="8.53271"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="4.85336"
            y1="4.62866"
            x2="3.48049"
            y2="3.25579"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="13.8495"
            y1="13.5896"
            x2="12.4766"
            y2="12.2167"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="4.87305"
            y1="12.07"
            x2="3.50017"
            y2="13.4428"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="13.9883"
            y1="3.16617"
            x2="12.6154"
            y2="4.53904"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined33: {
      viewBox: '0 0 21 14',
      path: (
        <>
          <path
            d="M10.6738 8.28125C8.46469 8.28125 6.67383 10.0721 6.67383 12.2812H14.6738C14.6738 10.0721 12.883 8.28125 10.6738 8.28125Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinejoin="round"
          />
          <line
            x1="10.6738"
            y1="4.83691"
            x2="10.6738"
            y2="1.28104"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="5.18735"
            y1="7.20996"
            x2="2.67297"
            y2="4.69558"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="18.6016"
            y1="4.69546"
            x2="16.0872"
            y2="7.20985"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M1.67383 12.2812L19.6738 12.2813"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined34: {
      viewBox: '0 0 17 14',
      path: (
        <>
          <path
            d="M8.34586 1.03979L15.1859 12.8798H1.50586L8.34586 1.03979Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M8.3418 5.77026V8.57026"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.3'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M8.34305 11.0804C8.74069 11.0804 9.06305 10.758 9.06305 10.3604C9.06305 9.96274 8.74069 9.64038 8.34305 9.64038C7.9454 9.64038 7.62305 9.96274 7.62305 10.3604C7.62305 10.758 7.9454 11.0804 8.34305 11.0804Z"
            fill="black"
          />
        </>
      ),
    },
    Outlined35: {
      viewBox: '0 0 16 23',
      path: (
        <>
          <path
            d="M12.0683 1.80566H3.73341C2.47512 1.80566 1.45508 2.83594 1.45508 4.10684V18.9175C1.45508 20.1884 2.47512 21.2187 3.73341 21.2187H12.0683C13.3266 21.2187 14.3466 20.1884 14.3466 18.9175V4.10684C14.3466 2.83594 13.3266 1.80566 12.0683 1.80566Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M5.86719 3.99194H9.93654"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M11.5915 5.91577H4.20591C3.90881 5.91577 3.66797 6.15903 3.66797 6.4591V18.3933C3.66797 18.6933 3.90881 18.9366 4.20591 18.9366H11.5915C11.8886 18.9366 12.1294 18.6933 12.1294 18.3933V6.4591C12.1294 6.15903 11.8886 5.91577 11.5915 5.91577Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M3.66797 8.03809H12.1294"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M5.86719 8.11467V5.91577"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.2'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined36: {
      viewBox: '0 0 22 17',
      path: (
        <>
          <path
            d="M19.282 1.19971H9.6951C9.00162 1.19971 8.43945 1.76188 8.43945 2.45535V4.63669C8.43945 5.33016 9.00162 5.89233 9.6951 5.89233H19.282C19.9755 5.89233 20.5376 5.33016 20.5376 4.63669V2.45535C20.5376 1.76188 19.9755 1.19971 19.282 1.19971Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M8.90039 9.19971H15.9004"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
            strokeLinejoin="round"
          />
          <path
            d="M8.90039 12.1997H20.9004"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
            strokeLinejoin="round"
          />
          <path
            d="M8.90039 15.1997H15.9004"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
            strokeLinejoin="round"
          />
          <path
            d="M5.68009 3.54614H0.900391"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M3.53906 1.40601L5.67916 3.5461L3.53906 5.6862"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined37: {
      viewBox: '0 0 21 20',
      path: (
        <>
          <path
            d="M8.097 13.7894C11.584 13.7894 14.4108 10.9627 14.4108 7.47566C14.4108 3.98865 11.584 1.16187 8.097 1.16187C4.60998 1.16187 1.7832 3.98865 1.7832 7.47566C1.7832 10.9627 4.60998 13.7894 8.097 13.7894Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M12.6699 12.0483L14.4521 13.8305"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M13.5684 14.7122L13.5725 14.708M13.5725 14.708L17.5686 18.7041C17.95 19.0855 18.5718 19.0855 18.9531 18.7041L19.3262 18.331C19.7076 17.9497 19.7076 17.3279 19.3262 16.9465L15.3301 12.9504L13.5725 14.708Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
          />
          <path
            d="M4.6543 6.10986L6.44819 9.3928L8.10138 6.10986L9.74285 9.38694L11.5367 6.10986"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined38: {
      viewBox: '0 0 23 19',
      path: (
        <>
          <path
            d="M11.4746 8.01245C12.5792 8.01245 13.4746 7.11702 13.4746 6.01245C13.4746 4.90788 12.5792 4.01245 11.4746 4.01245C10.37 4.01245 9.47461 4.90788 9.47461 6.01245C9.47461 7.11702 10.37 8.01245 11.4746 8.01245Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M9.38287 10.0125C8.16414 10.729 7.34961 12.0518 7.34961 13.5645C9.82994 15.2793 13.1125 15.2793 15.5929 13.5645C15.5929 12.0518 14.7783 10.729 13.5596 10.0125"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M3.83452 5.53223C2.12585 8.74747 2.62804 12.814 5.33496 15.5209C8.04189 18.2278 12.1145 18.73 15.3236 17.0213"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M7.37109 1.99886C10.5802 0.296316 14.6528 0.798506 17.3536 3.49931C20.0544 6.20011 20.5566 10.2727 18.8602 13.4757"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M18.834 13.4209L18.8462 13.4148L18.8646 13.4699L18.9197 13.4454L18.9258 13.4577L18.8585 13.4883L18.834 13.4209Z"
            fill="black"
          />
          <path
            d="M21.3416 12.361L18.8612 13.4879L17.7344 11.0076"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M1.34961 6.65909L3.83606 5.53223L4.9568 8.01868"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined39: {
      viewBox: '0 0 19 20',
      path: (
        <>
          <path
            d="M8.53657 2.54144C8.89677 1.73023 10.0481 1.73023 10.4083 2.54144C11.062 4.01374 12.7552 4.71507 14.2585 4.13627C15.0868 3.81736 15.9009 4.63144 15.582 5.45975C15.0032 6.96309 15.7045 8.65626 17.1768 9.31001C17.988 9.67021 17.988 10.8215 17.1768 11.1817C15.7045 11.8354 15.0032 13.5286 15.582 15.0319C15.9009 15.8603 15.0868 16.6743 14.2585 16.3554C12.7552 15.7766 11.062 16.478 10.4083 17.9503C10.0481 18.7615 8.89677 18.7615 8.53657 17.9503C7.88282 16.478 6.18966 15.7766 4.68632 16.3554C3.858 16.6743 3.04392 15.8603 3.36283 15.0319C3.94163 13.5286 3.2403 11.8354 1.76801 11.1817C0.956795 10.8215 0.956794 9.67021 1.76801 9.31001C3.2403 8.65626 3.94163 6.96309 3.36283 5.45975C3.04392 4.63144 3.858 3.81736 4.68632 4.13627C6.18966 4.71507 7.88282 4.01374 8.53657 2.54144Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <circle
            cx="9.6"
            cy="10.2"
            r="2.25556"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Outlined40: {
      viewBox: '0 0 18 18',
      path: (
        <>
          <rect
            x="1.99414"
            y="1.92749"
            width="14.9328"
            height="14.5441"
            rx="2"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="1.91406"
            y1="7.9978"
            x2="17.0916"
            y2="7.9978"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <circle cx="5.09555" cy="5.06015" r="0.997894" fill="white" />
          <circle cx="7.77914" cy="5.06015" r="0.997894" fill="white" />
          <circle cx="10.4608" cy="5.06015" r="0.997894" fill="white" />
        </>
      ),
    },
    Outlined41: {
      viewBox: '0 0 25 26',
      path: (
        <>
          <path
            d="M12.311 9.21749L13.6001 3.99573L14.8892 9.21749C14.9916 9.63219 15.3154 9.95598 15.7301 10.0584L20.9518 11.3474L15.7301 12.6365C15.3154 12.7389 14.9916 13.0627 14.8892 13.4774L13.6001 18.6991L12.311 13.4774C12.2087 13.0627 11.8849 12.7389 11.4702 12.6365L6.24842 11.3474L11.4702 10.0584C11.8849 9.95598 12.2087 9.63219 12.311 9.21749Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5'}
          />
          <path
            d="M5.66055 17.7742L6.38049 14.8579L7.10043 17.7742C7.18055 18.0988 7.43395 18.3522 7.7585 18.4323L10.6748 19.1522L7.7585 19.8722C7.43395 19.9523 7.18055 20.2057 7.10043 20.5302L6.38049 23.4465L5.66055 20.5302C5.58043 20.2057 5.32703 19.9523 5.00249 19.8722L2.08619 19.1522L5.00249 18.4323C5.32703 18.3522 5.58043 18.0988 5.66055 17.7742Z"
            stroke={props.stroke ? props.stroke : 'black'}
          />
        </>
      ),
    },
    Outlined42: {
      viewBox: '0 0 23 19',
      path: (
        <>
          <path
            d="M10.8926 6.31494C9.81217 5.80847 8.51786 5.81973 7.41487 6.46126C5.60283 7.49671 4.98381 9.80397 6.03052 11.616C7.07723 13.4168 9.38448 14.0358 11.1853 13.0004C12.2432 12.3926 12.896 11.3346 13.0423 10.1979"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M13.7037 3.40557C12.9937 2.90557 12.1837 2.52557 11.2937 2.28557C7.18368 1.18557 2.95368 3.62557 1.85368 7.73557C0.753684 11.8456 3.19368 16.0656 7.30368 17.1756C11.4137 18.2756 15.6437 15.8356 16.7437 11.7256C16.9737 10.8756 17.0437 10.0256 16.9737 9.19557"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M19.3987 1.73284C19.5211 1.66218 19.6762 1.73735 19.6966 1.87721L19.9326 3.49677C19.94 3.5473 19.9664 3.5931 20.0064 3.62478L21.293 4.64265C21.4038 4.73031 21.3913 4.9021 21.2689 4.97272L18.4017 6.62758C18.3307 6.66855 18.2419 6.66206 18.1776 6.61121L16.7664 5.49478C16.7264 5.4631 16.7 5.4173 16.6926 5.36677L16.4336 3.58969C16.4218 3.50864 16.4606 3.42858 16.5316 3.38763L19.3987 1.73284Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
          />
          <path
            d="M17.1196 6.19156C17.5261 5.95672 17.6652 5.43683 17.4304 5.03035C17.1955 4.62387 16.6756 4.48473 16.2692 4.71957L17.1196 6.19156ZM8.80916 9.02957L8.07316 9.45479L8.9236 10.9268L9.65959 10.5016L8.80916 9.02957ZM16.2692 4.71957L8.80916 9.02957L9.65959 10.5016L17.1196 6.19156L16.2692 4.71957Z"
            fill="white"
          />
        </>
      ),
    },
    Outlined43: {
      viewBox: '0 0 24 22',
      path: (
        <>
          <circle
            cx="10.0352"
            cy="10.2588"
            r="9"
            transform="rotate(-90 10.0352 10.2588)"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M18 16L22 20"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
          />
          <path
            d="M5.14209 11.8865V11.6865C5.14209 10.582 6.03752 9.68652 7.14209 9.68652H10.1707"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'square'}
          />
          <circle
            cx="12.9993"
            cy="10.0013"
            r="2.14286"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined44: {
      viewBox: '0 0 22 22',
      path: (
        <>
          <path
            d="M12.9376 20.5875H3.9375C2.83293 20.5875 1.9375 19.692 1.9375 18.5875V7.5874C1.9375 6.48283 2.83293 5.5874 3.9375 5.5874H10.793C11.2875 5.5874 11.7645 5.77061 12.1318 6.10165L13.1979 7.06229L13.1998 7.06406L14.2844 8.05209C14.7005 8.43108 14.9376 8.96781 14.9376 9.53059V18.5875C14.9376 19.692 14.0421 20.5875 12.9376 20.5875Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="8.39063"
            y1="10.7852"
            x2="8.39062"
            y2="16.3394"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="11.2168"
            y1="13.5803"
            x2="5.66257"
            y2="13.5803"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M14.5601 15.6273H18.0476C19.1522 15.6273 20.0476 14.7318 20.0476 13.6272V5.40715C20.0476 4.84437 19.8105 4.30764 19.3945 3.92865L18.3332 2.96184L17.3057 2.03598C16.9384 1.70494 16.4614 1.52173 15.9669 1.52173H9.60156C8.49699 1.52173 7.60156 2.41716 7.60156 3.52173V6.24393"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M15.3105 0.975098V4.67971C15.3105 5.78428 16.206 6.67971 17.3105 6.67971H20.6529"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined45: {
      viewBox: '0 0 22 22',
      path: (
        <>
          <line
            x1="15.9287"
            y1="15.6157"
            x2="6.98438"
            y2="6.67136"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="15.7949"
            y1="6.65036"
            x2="6.85055"
            y2="15.5947"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2.2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined46: {
      viewBox: '0 0 18 19',
      path: (
        <>
          <path
            d="M14.0923 17.4324H3.97461C2.87004 17.4324 1.97461 16.537 1.97461 15.4324V3.16577C1.97461 2.0612 2.87004 1.16577 3.97461 1.16577H11.6502C12.1447 1.16577 12.6217 1.34898 12.9891 1.68002L14.2007 2.77183L14.2026 2.7736L15.4391 3.90001C15.8552 4.279 16.0923 4.81574 16.0923 5.37852V15.4324C16.0923 16.537 15.1968 17.4324 14.0923 17.4324Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M10.1777 0.165771V5.26289C10.1777 6.36746 11.0732 7.26289 12.1777 7.26289H16.8242"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M4.19727 5.47657L9.51098 5.47656"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <path
            d="M4.19727 14.1245L13.8679 14.1245"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
          <line
            x1="4.19727"
            y1="9.87524"
            x2="11.6021"
            y2="9.87525"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
          />
        </>
      ),
    },
    Outlined47: {
      viewBox: '0 0 21 23',
      path: (
        <>
          <path
            d="M16.0881 11.8151V6.60697C16.0881 5.76281 15.7324 4.95771 15.1084 4.38922L14.0705 3.44377L13.0458 2.5204C12.4948 2.02383 11.7793 1.74902 11.0375 1.74902H4.44141C2.78455 1.74902 1.44141 3.09217 1.44141 4.74902V15.3486C1.44141 17.0054 2.78455 18.3486 4.4414 18.3486H8.76474"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
          />
          <path
            d="M9.80469 1.74878V6.19817C9.80469 7.30274 10.7001 8.19817 11.8047 8.19817H15.8445"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
          />
          <line
            x1="15.9306"
            y1="21.6904"
            x2="15.9306"
            y2="14.523"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <line
            x1="12.3975"
            y1="18.0561"
            x2="19.5648"
            y2="18.0561"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined48: {
      viewBox: '0 0 16 20',
      path: (
        <>
          <path
            d="M7.95875 8.94411C9.88622 8.94411 11.4488 7.38159 11.4488 5.45411C11.4488 3.52664 9.88622 1.96411 7.95875 1.96411C6.03128 1.96411 4.46875 3.52664 4.46875 5.45411C4.46875 7.38159 6.03128 8.94411 7.95875 8.94411Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M4.54852 10.7341C2.55852 11.9041 1.22852 14.0641 1.22852 16.5341C5.27852 19.3341 10.6385 19.3341 14.6885 16.5341C14.6885 14.0641 13.3585 11.9041 11.3685 10.7341"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined49: {
      viewBox: '0 0 14 10',
      path: (
        <>
          <path
            d="M1.77344 4.26793L5.47407 7.96856L12.1914 1.25122"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },
    Outlined50: {
      viewBox: '0 0 21 20',
      path: (
        <>
          <path
            d="M1.05664 3.0533L11.7637 3.0533M6.41016 1.2688L6.41016 3.0533M7.34524 11.5297C5.97126 10.1073 4.87145 8.44369 4.10101 6.62231M9.53304 14.6526L15.7788 14.6526M8.19466 17.3293L12.6559 8.40682L17.1172 17.3293M9.757 3.0533C8.8933 8.2016 5.58036 12.5201 1.05664 14.7677"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined51: {
      viewBox: '0 0 19 17',
      path: (
        <>
          <path
            d="M18.0361 5.76854L11.6826 0.812782C11.3649 0.571348 10.9456 0.520519 10.5898 0.698418C10.234 0.876317 10.0053 1.23212 10.0053 1.62603V3.22713C7.85777 3.03652 5.73569 3.67187 4.08377 5.04424C2.21583 6.58179 1.14844 8.85636 1.14844 11.2834C1.14844 12.6431 1.49153 13.9773 2.13959 15.1591C2.35561 15.5657 2.76224 15.8071 3.21969 15.8071C3.25781 15.8071 3.29593 15.8071 3.34676 15.8071C3.85504 15.7563 4.26167 15.4259 4.41416 14.943C5.24012 12.3508 7.41302 10.4956 10.018 10.0381V11.5376C10.018 11.9315 10.2467 12.3 10.6025 12.4652C10.7423 12.5414 10.9075 12.5668 11.06 12.5668C11.2887 12.5668 11.5047 12.4906 11.6953 12.3508L14.0969 10.4829L14.8721 9.88563L16.0792 8.94531L16.8036 8.3862L18.0488 7.42046C18.303 7.21715 18.4428 6.92488 18.4428 6.60721C18.4428 6.28953 18.303 5.98456 18.0488 5.79395L18.0361 5.76854ZM17.5024 6.70886L16.4223 7.54753L15.7235 8.09393L13.9318 9.47901L13.0931 10.1398L11.1489 11.6519C11.0854 11.7027 11.0091 11.69 10.9837 11.6646C10.9456 11.6519 10.8948 11.6138 10.8948 11.5248V9.04697C10.6025 9.04697 10.3102 9.08509 10.018 9.13591C7.03181 9.60608 4.51581 11.7027 3.57549 14.6635C3.49925 14.8795 3.30864 14.9176 3.25781 14.9176C3.18157 14.9176 3.01638 14.9176 2.91472 14.727C2.3429 13.6723 2.03793 12.4779 2.03793 11.2707C2.03793 9.1105 2.99096 7.09008 4.65559 5.70501C5.95171 4.6249 7.57822 4.06579 9.25555 4.06579C9.50969 4.06579 9.76383 4.06579 10.0053 4.10391C10.2213 4.12933 10.45 4.15474 10.666 4.20557C10.7423 4.21828 10.8058 4.23098 10.8821 4.2564V1.63874C10.8821 1.54979 10.9329 1.51167 10.971 1.49896C10.9837 1.49896 11.0091 1.48626 11.0472 1.48626C11.0727 1.48626 11.1108 1.48626 11.1362 1.52438L17.4897 6.46743C17.4897 6.46743 17.5533 6.56909 17.5533 6.5945C17.5533 6.61991 17.5533 6.68345 17.4897 6.72157L17.5024 6.70886Z"
            fill="black"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeMiterlimit="10"
          />
        </>
      ),
    },
    Outlined52: {
      viewBox: '0 0 19 17',
      path: (
        <>
          <path
            d="M8.25113 1.99086C8.50661 1.26184 9.61628 1.26184 9.87092 1.99086L11.1645 5.6906C11.2202 5.8493 11.3284 5.98758 11.4737 6.08567C11.619 6.18377 11.794 6.23665 11.9736 6.23678H16.1593C16.9846 6.23678 17.3269 7.21831 16.6601 7.6695L13.274 9.95552C13.1286 10.0538 13.0203 10.1923 12.9648 10.3513C12.9093 10.5103 12.9093 10.6815 12.9649 10.8405L14.2576 14.5402C14.5131 15.27 13.6147 15.8764 12.9478 15.4252L9.56178 13.1392C9.41625 13.0408 9.24095 12.9879 9.06102 12.9879C8.8811 12.9879 8.7058 13.0408 8.56027 13.1392L5.1742 15.4252C4.50737 15.8764 3.60891 15.2692 3.8644 14.5402L5.15717 10.8405C5.21276 10.6815 5.21279 10.5103 5.15726 10.3513C5.10172 10.1923 4.99348 10.0538 4.84802 9.95552L1.46196 7.6695C0.794281 7.21831 1.13834 6.23678 1.96271 6.23678H6.14761C6.32734 6.23682 6.50248 6.18401 6.64796 6.0859C6.79343 5.9878 6.90179 5.84943 6.9575 5.6906L8.25113 1.99086Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined53: {
      viewBox: '0 0 21 21',
      path: (
        <>
          <path
            d="M12.2087 8.28125H17.036C17.3814 8.28126 17.721 8.36839 18.0227 8.53437C18.3244 8.70035 18.5781 8.93967 18.7597 9.22961C18.9413 9.51955 19.0449 9.85049 19.0604 10.191C19.076 10.5315 19.0032 10.8703 18.8488 11.1753L15.3023 18.1752C15.1339 18.5077 14.875 18.7873 14.5546 18.9827C14.2343 19.178 13.8651 19.2814 13.4885 19.2812H9.41808C9.25292 19.2812 9.08775 19.2613 8.92664 19.2213L5.11566 18.2812M12.2087 8.28125V3.28125C12.2087 2.75082 11.9952 2.24211 11.6151 1.86704C11.2351 1.49196 10.7196 1.28125 10.1821 1.28125H10.0858C9.57919 1.28125 9.16881 1.68625 9.16881 2.18625C9.16881 2.90025 8.95501 3.59825 8.55273 4.19225L5.11566 9.28125V18.2812M12.2087 8.28125H10.1821M5.11566 18.2812H3.08908C2.5516 18.2812 2.03613 18.0705 1.65607 17.6955C1.27601 17.3204 1.0625 16.8117 1.0625 16.2812V10.2812C1.0625 9.75082 1.27601 9.24211 1.65607 8.86704C2.03613 8.49196 2.5516 8.28125 3.08908 8.28125H5.6223"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined54: {
      viewBox: '0 0 21 21',
      path: (
        <>
          <path
            d="M15.0083 2.60986L11.1984 1.66986C11.0376 1.63011 10.8726 1.60996 10.7069 1.60986H6.63552C6.25909 1.60988 5.8901 1.71336 5.56992 1.9087C5.24974 2.10405 4.99101 2.38355 4.82275 2.71586L1.27624 9.71586C1.12184 10.0208 1.04898 10.3596 1.06456 10.7001C1.08015 11.0406 1.18366 11.3716 1.36528 11.6615C1.54689 11.9514 1.80058 12.1908 2.10227 12.3567C2.40395 12.5227 2.74361 12.6099 3.08901 12.6099H7.91632H9.9429M15.0083 2.60986L15.0093 11.6099L11.5723 16.6979C11.17 17.2929 10.9562 17.9909 10.9562 18.7059C10.9562 19.2049 10.5458 19.6099 10.0392 19.6099H9.94188C9.4044 19.6099 8.88893 19.3991 8.50888 19.0241C8.12882 18.649 7.91531 18.1403 7.91531 17.6099V12.6099M15.0083 2.60986H17.0359C17.5734 2.60986 18.0889 2.82058 18.4689 3.19565C18.849 3.57072 19.0625 4.07943 19.0625 4.60986V10.6099C19.0625 11.1403 18.849 11.649 18.4689 12.0241C18.0889 12.3991 17.5734 12.6099 17.0359 12.6099H14.5027"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined55: {
      viewBox: '0 0 10 18',
      path: (
        <>
          <path
            d="M2.8625 16.1997C2.8625 16.5863 3.1759 16.8997 3.5625 16.8997H5.8125C6.1991 16.8997 6.5125 16.5863 6.5125 16.1997V9.57195H8.0625C8.4491 9.57195 8.7625 9.25855 8.7625 8.87195V6.64787C8.7625 6.26127 8.4491 5.94787 8.0625 5.94787H6.5125V5.16515C6.5125 5.15864 6.51449 5.1497 6.52491 5.1394C6.53545 5.12898 6.54827 5.12379 6.5625 5.12379H8.0625C8.4491 5.12379 8.7625 4.81039 8.7625 4.42379V2.19971C8.7625 1.81311 8.4491 1.49971 8.0625 1.49971H6.1875C4.36107 1.49971 2.8625 2.96942 2.8625 4.79447V5.94787H2.0625C1.6759 5.94787 1.3625 6.26127 1.3625 6.64787V8.87195C1.3625 9.25855 1.6759 9.57195 2.0625 9.57195H2.8625V16.1997Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined56: {
      viewBox: '0 0 20 17',
      path: (
        <>
          <path
            d="M18.6449 3.71681C18.8183 3.45673 18.7983 3.11319 18.5958 2.87505C18.4776 2.73605 18.314 2.65263 18.1417 2.63296C18.1961 2.50789 18.2445 2.37931 18.2862 2.24758C18.3742 1.96994 18.2811 1.66684 18.0524 1.48649C17.8237 1.30614 17.5072 1.28623 17.2577 1.4365C16.7957 1.71482 16.289 1.9266 15.7517 2.06985C15.044 1.44904 14.1281 1.09907 13.1218 1.09907C10.9459 1.09907 9.17235 2.8664 9.15611 5.04943C6.97389 4.72946 5.05094 3.59228 3.72181 1.96103C3.577 1.78331 3.35435 1.68775 3.12578 1.70523C2.8972 1.7227 2.69166 1.85099 2.57556 2.04866C2.23009 2.6368 2.03554 3.3249 2.03554 4.04731C2.03554 4.6545 2.17048 5.23308 2.4144 5.75044C2.38936 5.76187 2.36485 5.77484 2.341 5.78936C2.13232 5.91637 2.00495 6.143 2.00495 6.38731V6.41025C2.00495 7.55557 2.48868 8.58995 3.26306 9.31727C3.15777 9.48897 3.13049 9.69997 3.19287 9.89572C3.44503 10.6871 3.93888 11.3795 4.60496 11.8756C4.77431 12.0018 4.95263 12.1136 5.13806 12.2105C4.41783 12.5148 3.6386 12.6729 2.84599 12.6691V12.6691H2.84261C2.61009 12.6691 2.37736 12.6554 2.14428 12.628C1.82056 12.5899 1.51339 12.7803 1.40349 13.0872C1.29359 13.394 1.41003 13.7361 1.68432 13.9122C3.24635 14.9151 5.10543 15.4991 7.09501 15.4991C13.5882 15.4991 17.1334 10.0995 17.1334 5.46201V5.4549C17.1334 5.42897 17.1334 5.40262 17.1334 5.37586C17.7205 4.90586 18.2273 4.3432 18.6449 3.71681ZM2.83924 14.0691C2.83981 14.0691 2.84037 14.0691 2.84093 14.0691L2.0625 13.3232C2.31391 13.4846 2.57357 13.6343 2.84068 13.7716L2.83924 14.0691Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.4'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined57: {
      viewBox: '0 0 22 17',
      path: (
        <>
          <path
            d="M1.68359 3.345V13.6796C1.68359 14.2278 1.90136 14.7535 2.28898 15.1412C2.67661 15.5288 3.20234 15.7466 3.75052 15.7466H18.219C18.7672 15.7466 19.2929 15.5288 19.6805 15.1412C20.0682 14.7535 20.2859 14.2278 20.2859 13.6796V5.41193C20.2859 4.86374 20.0682 4.33801 19.6805 3.95039C19.2929 3.56277 18.7672 3.345 18.219 3.345H12.0182L9.95129 1.27808H3.75052C3.20234 1.27808 2.67661 1.49584 2.28898 1.88346C1.90136 2.27109 1.68359 2.79682 1.68359 3.345Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.92'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined58: {
      viewBox: '0 0 12 13',
      path: (
        <>
          <path
            d="M6.56883 6.60984C6.56883 4.57984 8.08883 2.92984 10.0488 2.67984C9.11883 1.84984 7.90883 1.33984 6.56883 1.33984C3.65883 1.33984 1.29883 3.69984 1.29883 6.60984C1.29883 9.51984 3.65883 11.8798 6.56883 11.8798C7.90883 11.8798 9.11883 11.3598 10.0488 10.5398C8.08883 10.2898 6.56883 8.63984 6.56883 6.60984Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined59: {
      viewBox: '0 0 17 16',
      path: (
        <>
          <path
            d="M6.35843 8.19951L7.90173 9.74281L10.9883 6.6562M15.6183 8.19951C15.6183 9.11152 15.4386 10.0146 15.0896 10.8572C14.7406 11.6998 14.229 12.4654 13.5841 13.1103C12.9393 13.7552 12.1737 14.2667 11.3311 14.6157C10.4885 14.9647 9.5854 15.1444 8.67339 15.1444C7.76137 15.1444 6.85829 14.9647 6.0157 14.6157C5.17311 14.2667 4.40751 13.7552 3.76262 13.1103C3.11773 12.4654 2.60617 11.6998 2.25716 10.8572C1.90815 10.0146 1.72852 9.11152 1.72852 8.19951C1.72852 6.35761 2.46021 4.59116 3.76262 3.28874C5.06504 1.98633 6.83149 1.25464 8.67339 1.25464C10.5153 1.25464 12.2817 1.98633 13.5841 3.28874C14.8866 4.59116 15.6183 6.35761 15.6183 8.19951Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5433'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined60: {
      viewBox: '0 0 17 17',
      path: (
        <>
          <path
            d="M3.5 7H6.5"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5433'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M1 13.5V6C1 4.89543 1.89543 4 3 4H6.92963C7.59834 4 8.2228 4.3342 8.59373 4.8906L9.40627 6.1094C9.7772 6.6658 10.4017 7 11.0704 7H13.5C14.6046 7 15.5 7.89543 15.5 9V13.5C15.5 14.6046 14.6046 15.5 13.5 15.5H3C1.89543 15.5 1 14.6046 1 13.5Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5433'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M3 4V3C3 1.89543 3.89543 1 5 1H12.5C13.6046 1 14.5 1.89543 14.5 3V7"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.5433'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Outlined61: {
      viewBox: '0 0 8 19',
      path: (
        <path
          d="M2.8523 12.8823C3.37011 12.8823 3.86671 13.0938 4.23286 13.4701C4.599 13.8465 4.8047 14.3569 4.8047 14.8892C4.8047 15.4214 4.599 15.9319 4.23286 16.3082C3.86671 16.6846 3.37011 16.896 2.8523 16.896C2.33449 16.896 1.83789 16.6846 1.47175 16.3082C1.1056 15.9319 0.899902 15.4214 0.899902 14.8892C0.899902 14.3569 1.1056 13.8465 1.47175 13.4701C1.83789 13.0938 2.33449 12.8823 2.8523 12.8823ZM2.8523 6.86182C3.37011 6.86182 3.86671 7.07325 4.23286 7.4496C4.599 7.82596 4.8047 8.33641 4.8047 8.86865C4.8047 9.4009 4.599 9.91134 4.23286 10.2877C3.86671 10.6641 3.37011 10.8755 2.8523 10.8755C2.33449 10.8755 1.83789 10.6641 1.47175 10.2877C1.1056 9.91134 0.899902 9.4009 0.899902 8.86865C0.899902 8.33641 1.1056 7.82596 1.47175 7.4496C1.83789 7.07325 2.33449 6.86182 2.8523 6.86182ZM4.8047 2.84814C4.8047 2.3159 4.599 1.80545 4.23286 1.4291C3.86671 1.05274 3.37011 0.841308 2.8523 0.841309C2.33449 0.841309 1.83789 1.05274 1.47175 1.4291C1.1056 1.80545 0.899902 2.3159 0.899902 2.84814C0.899902 3.38039 1.1056 3.89084 1.47175 4.26719C1.83789 4.64355 2.33449 4.85498 2.8523 4.85498C3.37011 4.85498 3.86671 4.64355 4.23286 4.26719C4.599 3.89084 4.8047 3.38039 4.8047 2.84814Z"
          fill={props.svgFill ? props.svgFill : 'black'}
          stroke={props.stroke ? props.stroke : 'black'}
        />
      ),
    },
    Outlined62: {
      viewBox: '0 0 23 19',
      path: (
        <>
          <path
            d="M3.83452 5.56738C2.12585 8.78262 2.62804 12.8491 5.33496 15.5561C8.04189 18.263 12.1145 18.7652 15.3236 17.0565"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M7.37012 2.03426C10.5792 0.331716 14.6519 0.833906 17.3527 3.53471C20.0535 6.23551 20.5557 10.3081 18.8592 13.5111"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M18.834 13.4563L18.8462 13.4502L18.8646 13.5053L18.9197 13.4808L18.9258 13.4931L18.8585 13.5237L18.834 13.4563Z"
            fill="black"
          />
          <path
            d="M21.3425 12.3964L18.8622 13.5233L17.7354 11.043"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
          <path
            d="M1.34961 6.69425L3.83606 5.56738L4.9568 8.05383"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '1.7'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
            strokeLinejoin="round"
          />
        </>
      ),
    },

    Outlined63: {
      viewBox: '0 0 53 53',
      path: (
        <>
          <path
            d="M43.375 30.0981V14.2263C43.375 12.5379 42.6637 10.9277 41.4156 9.79076L37.6552 6.36517L34.0354 3.1033C32.9333 2.11017 31.5024 1.56055 30.0188 1.56055H7.85156C4.53785 1.56055 1.85156 4.24683 1.85156 7.56054V42.6204C1.85156 45.9342 4.53785 48.6204 7.85156 48.6204H32.6623"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
          />
          <path
            d="M25.5625 1.56055V16.8446C25.5625 18.5015 26.9056 19.8446 28.5625 19.8446H42.6855"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
          />
          <path
            d="M39.7852 51.3468C45.8302 51.3468 50.7306 46.4464 50.7306 40.4014C50.7306 34.3565 45.8302 29.4561 39.7852 29.4561C33.7403 29.4561 28.8398 34.3565 28.8398 40.4014C28.8398 46.4464 33.7403 51.3468 39.7852 51.3468Z"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
          />
          <path
            d="M39.7842 44.875L39.7842 37.875"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M35.8955 39.8184L39.0772 36.6364C39.4677 36.2458 40.1009 36.2458 40.4914 36.6363L43.6735 39.8184"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '2'}
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },

    Outlined64: {
      viewBox: '0 0 17 16',
      path: (
        <>
          <path
            d="M6.16129 7.72514L7.70459 9.26845L10.7912 6.18184M15.4211 7.72514C15.4211 8.63716 15.2415 9.54024 14.8925 10.3828C14.5435 11.2254 14.0319 11.991 13.387 12.6359C12.7421 13.2808 11.9765 13.7924 11.1339 14.1414C10.2913 14.4904 9.38826 14.67 8.47624 14.67C7.56423 14.67 6.66115 14.4904 5.81856 14.1414C4.97596 13.7924 4.21037 13.2808 3.56548 12.6359C2.92059 11.991 2.40903 11.2254 2.06002 10.3828C1.71101 9.54024 1.53137 8.63716 1.53137 7.72514C1.53137 5.88325 2.26306 4.11679 3.56548 2.81438C4.86789 1.51196 6.63435 0.780273 8.47624 0.780273C10.3181 0.780273 12.0846 1.51196 13.387 2.81438C14.6894 4.11679 15.4211 5.88325 15.4211 7.72514Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.5433"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },

    Outlined64: {
      viewBox: '0 0 23 14',
      path: (
        <>
          <path
            d="M20.4382 1.13574H0.561523V13.0199H20.4382V1.13574Z"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeWidth="1.6"
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M16.4002 10.7553H4.59998C4.59998 9.82912 3.84737 9.08148 2.91504 9.08148V5.08105C3.84737 5.08105 4.59998 4.33341 4.59998 3.40723H16.4002C16.4002 4.33341 17.1528 5.08105 18.0851 5.08105V9.08148C17.1528 9.08148 16.4002 9.82912 16.4002 10.7553Z"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M9.58154 7.92005C9.58154 8.38314 10.0702 8.76254 10.6655 8.76254C11.2609 8.76254 11.7495 8.38872 11.7495 7.92005C11.7495 7.45138 11.2609 7.07756 10.6655 7.07756C10.0702 7.07756 9.58154 6.70374 9.58154 6.23507C9.58154 5.7664 10.0702 5.39258 10.6655 5.39258C11.2609 5.39258 11.7495 5.7664 11.7495 6.23507"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M10.6655 5.39835V4.89062"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
          <path
            d="M10.6655 9.26456V8.75684"
            stroke={props.stroke ? props.stroke : '#7A818C'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
            strokeLinecap={props.strokeLinecap ? props.strokeLinecap : 'round'}
          />
        </>
      ),
    },

    Outlined65: {
      viewBox: '0 0 23 17',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6562 0.578125C15.2085 0.578125 15.6562 1.02584 15.6562 1.57812V1.89805H21.3314H22.8409L22.0583 3.18875L21.2576 4.50925L22.0583 5.82974L22.8409 7.12045H21.3314H15.6562V10.1235C16.9569 10.5513 17.8856 11.7886 17.8856 13.229C17.8856 15.0183 16.4526 16.4942 14.6538 16.4942C13.2046 16.4942 11.9929 15.5364 11.5765 14.2285H6.30913C5.89275 15.5364 4.68101 16.4942 3.23188 16.4942C1.43306 16.4942 0 15.0183 0 13.229C0 11.4397 1.43306 9.96387 3.23188 9.96387C4.68062 9.96387 5.8921 10.9212 6.30879 12.2285H11.5768C11.8932 11.236 12.6677 10.4452 13.6562 10.1219V1.57812C13.6562 1.02584 14.104 0.578125 14.6562 0.578125ZM15.6562 5.42045H19.822L19.5367 4.94995L19.2695 4.50925L19.5367 4.06854L19.822 3.59805H15.6562V5.42045ZM3.23188 11.9639C2.56544 11.9639 2 12.5163 2 13.229C2 13.9418 2.56544 14.4942 3.23188 14.4942C3.89833 14.4942 4.46377 13.9418 4.46377 13.229C4.46377 12.5163 3.89833 11.9639 3.23188 11.9639ZM13.4231 13.2874C13.453 13.9717 14.0056 14.4942 14.6538 14.4942C15.3202 14.4942 15.8856 13.9418 15.8856 13.229C15.8856 12.5163 15.3202 11.9639 14.6538 11.9639C14.0058 11.9639 13.4533 12.486 13.4232 13.1701C13.4243 13.1894 13.4249 13.2089 13.4249 13.2285C13.4249 13.2483 13.4243 13.2679 13.4231 13.2874Z"
            fill={props.stroke ? props.stroke : 'black'}
          />
        </>
      ),
    },

    Outlined66: {
      viewBox: '0 0 35 69',
      path: (
        <>
          <path
            d="M17.251 48.0698H24.5547C25.0605 48.0698 25.4866 47.6922 25.5475 47.1901L26.3614 40.4732C28.8161 19.2418 28.8697 14.7066 17.996 2.45664C17.6023 2.01316 16.8995 2.01306 16.5057 2.45643C5.62538 14.7066 5.67913 19.2416 8.14047 40.4732L8.95446 47.1901C9.01531 47.6922 9.44144 48.0698 9.9472 48.0698H17.251Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
          />
          <path
            d="M8.33801 43.8613H26.1567"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
          />
          <path
            d="M17.2508 26.7726C20.3165 26.7726 22.8017 24.2874 22.8017 21.2217C22.8017 18.1561 20.3165 15.6709 17.2508 15.6709C14.1852 15.6709 11.7 18.1561 11.7 21.2217C11.7 24.2874 14.1852 26.7726 17.2508 26.7726Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
          />
          <path
            d="M7.30854 33.9541C4.01486 36.034 1.98272 39.6345 1.89407 43.5283L1.83141 46.4391C1.80989 47.4386 3.10638 47.8476 3.66231 47.0167L8.08593 40.4051"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
          />
          <path
            d="M27.1864 33.9531C30.4801 36.033 32.5123 39.6335 32.6009 43.5273L32.6636 46.4381C32.6851 47.4376 31.3886 47.8466 30.8327 47.0157L26.4091 40.4041"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeMiterlimit={
              props.strokeMiterlimit ? props.strokeMiterlimit : '10'
            }
          />
          <rect
            x="14.8397"
            y="38.5996"
            width="4.8154"
            height="13.7636"
            rx="1.5"
            fill="#F8FCFD"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
          />
          <line
            x1="11.0192"
            y1="53.4736"
            x2="11.0192"
            y2="61.5279"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeLinecap="round"
          />
          <line
            x1="24.3018"
            y1="53.4746"
            x2="24.3018"
            y2="61.5289"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeLinecap="round"
          />
          <line
            x1="17.3881"
            y1="59.001"
            x2="17.3881"
            y2="67.0553"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth={props.strokeWidth ? props.strokeWidth : '3'}
            strokeLinecap="round"
          />
        </>
      ),
    },

    Filled1: {
      viewBox: '0 0 18 21',
      path: (
        <>
          <g clipPath="url(#clip0_947_84542)">
            <path
              fill={props.svgFill ? props.svgFill : 'black'}
              d="M16.936 0.526855H0.865234V19.5888H16.936V0.526855Z"
              stroke={props.stroke ? props.stroke : 'black'}
              strokeWidth="1.9"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.75344 3.93677H3.29102V6.4227H5.75344V3.93677Z"
              stroke={props.stroke ? props.stroke : 'white'}
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M5.75344 8.8147H3.29102V11.3006H5.75344V8.8147Z"
              stroke={props.stroke ? props.stroke : 'white'}
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M5.75344 13.6929H3.29102V16.1788H5.75344V13.6929Z"
              stroke={props.stroke ? props.stroke : 'white'}
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M8.40039 6.05786H14.4004"
              stroke={props.stroke ? props.stroke : 'white'}
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M8.40039 11.0579H14.4004"
              stroke={props.stroke ? props.stroke : 'white'}
              strokeWidth="1.4"
              strokeLinecap="square"
            />
            <path
              d="M8.40039 16.0579H14.4004"
              stroke={props.stroke ? props.stroke : 'white'}
              strokeWidth="1.4"
              strokeLinecap="square"
            />
          </g>
          <defs>
            <clipPath id="clip0_947_84542">
              <rect
                width="17"
                height="20"
                fill={props.svgFill ? props.svgFill : 'white'}
                transform="translate(0.400391 0.0578613)"
              />
            </clipPath>
          </defs>
        </>
      ),
    },
    Filled2: {
      viewBox: '0 0 20 17',
      path: (
        <>
          <path
            d="M9.78952 3.11174V15.5453ZM9.78952 3.11174C8.67241 2.36955 7.15551 1.91333 5.48558 1.91333C3.81565 1.91333 2.29875 2.36955 1.18164 3.11174V15.5453C2.29875 14.8032 3.81565 14.3469 5.48558 14.3469C7.15551 14.3469 8.67241 14.8032 9.78952 15.5453M9.78952 3.11174C10.9066 2.36955 12.4235 1.91333 14.0935 1.91333C15.7643 1.91333 17.2803 2.36955 18.3974 3.11174V15.5453C17.2803 14.8032 15.7643 14.3469 14.0935 14.3469C12.4235 14.3469 10.9066 14.8032 9.78952 15.5453"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M9.78952 3.11174V15.5453M9.78952 3.11174C8.67241 2.36955 7.15551 1.91333 5.48558 1.91333C3.81565 1.91333 2.29875 2.36955 1.18164 3.11174V15.5453C2.29875 14.8032 3.81565 14.3469 5.48558 14.3469C7.15551 14.3469 8.67241 14.8032 9.78952 15.5453M9.78952 3.11174C10.9066 2.36955 12.4235 1.91333 14.0935 1.91333C15.7643 1.91333 17.2803 2.36955 18.3974 3.11174V15.5453C17.2803 14.8032 15.7643 14.3469 14.0935 14.3469C12.4235 14.3469 10.9066 14.8032 9.78952 15.5453"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled3: {
      viewBox: '0 0 15 19',
      path: (
        <>
          <rect
            x="1.38477"
            y="7.39746"
            width="11.7331"
            height="9.82246"
            rx="2"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M4.63086 10.0266V4.51628C4.63086 3.06927 5.80389 1.89624 7.2509 1.89624V1.89624C8.69791 1.89624 9.87094 3.06927 9.87094 4.51628V10.0266"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M4.63086 6.39844V4.51628C4.63086 3.06927 5.80389 1.89624 7.2509 1.89624V1.89624C8.69791 1.89624 9.87094 3.06927 9.87094 4.51628V6.40234"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled4: {
      viewBox: '0 0 19 19',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.69236 2.90019C6.49803 2.90019 5.35261 3.37464 4.50809 4.21916C3.66357 5.06368 3.18912 6.2091 3.18912 7.40343C3.18912 8.59777 3.66357 9.74318 4.50809 10.5877C5.35261 11.4322 6.49803 11.9067 7.69236 11.9067C8.8867 11.9067 10.0321 11.4322 10.8766 10.5877C11.7212 9.74318 12.1956 8.59777 12.1956 7.40343C12.1956 6.2091 11.7212 5.06368 10.8766 4.21916C10.0321 3.37464 8.8867 2.90019 7.69236 2.90019ZM0.9375 7.40343C0.937364 6.34033 1.18815 5.29221 1.66947 4.34431C2.15079 3.39641 2.84904 2.5755 3.70744 1.94834C4.56584 1.32119 5.56015 0.905491 6.6095 0.735067C7.65885 0.564643 8.73361 0.644302 9.74637 0.967566C10.7591 1.29083 11.6813 1.84857 12.4378 2.59543C13.1944 3.34228 13.764 4.25717 14.1003 5.26567C14.4366 6.27417 14.5302 7.34781 14.3733 8.39927C14.2164 9.45073 13.8136 10.4503 13.1976 11.3167L18.6206 16.7398C18.8257 16.9521 18.9392 17.2365 18.9366 17.5317C18.934 17.8269 18.8156 18.1092 18.6069 18.318C18.3982 18.5267 18.1158 18.6451 17.8206 18.6477C17.5254 18.6502 17.241 18.5368 17.0287 18.3317L11.6068 12.9098C10.5962 13.6284 9.40737 14.0549 8.17047 14.1427C6.93357 14.2304 5.69638 13.976 4.59447 13.4073C3.49256 12.8387 2.56845 11.9776 1.9234 10.9186C1.27835 9.85959 0.937259 8.64344 0.9375 7.40343Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    Filled5: {
      viewBox: '0 0 18 16',
      path: (
        <>
          <rect
            x="2.07227"
            y="1.89355"
            width="14.3235"
            height="12.3286"
            rx="2"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M16.3418 2.83984L10.5318 8.3902C9.75804 9.12943 8.53943 9.12855 7.76669 8.3882L1.9756 2.83984"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled6: {
      viewBox: '0 0 20 18',
      path: (
        <>
          <path
            d="M5.78906 5.03318L15.7296 2.04954V14.2597L5.78906 11.276V5.03318Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <mask
            id="path-2-inside-1_947_84412"
            fill={props.svgFill ? props.svgFill : 'white'}
          >
            <rect
              x="0.255859"
              y="3.98706"
              width="6.71875"
              height="8.33526"
              rx="1"
            />
          </mask>
          <rect
            x="0.255859"
            y="3.98706"
            width="6.71875"
            height="8.33526"
            rx="1"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="4"
            mask="url(#path-2-inside-1_947_84412)"
          />
          <line
            x1="3.46094"
            y1="11.8691"
            x2="3.46094"
            y2="16.2153"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="5.28906"
            y1="3.98706"
            x2="5.28906"
            y2="12.3223"
            stroke={props.stroke ? props.stroke : 'white'}
          />
          <path
            d="M16.4844 10.4271C17.7393 10.4271 18.7566 9.40976 18.7566 8.15483C18.7566 6.89989 17.7393 5.88257 16.4844 5.88257"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled7: {
      viewBox: '0 0 17 18',
      path: (
        <>
          <rect
            x="1.51953"
            y="1.18091"
            width="14.3235"
            height="15.5586"
            rx="2"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <line
            x1="4.03125"
            y1="5.12329"
            x2="13.3315"
            y2="5.12329"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <line
            x1="4.03125"
            y1="9.14771"
            x2="13.3315"
            y2="9.14771"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <line
            x1="4.03125"
            y1="13.1721"
            x2="13.3315"
            y2="13.1721"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled8: {
      viewBox: '0 0 18 17',
      path: (
        <>
          <path
            d="M12.7539 0.582275H2.39453C1.28996 0.582275 0.394531 1.47771 0.394531 2.58228V14.1326C0.394531 15.2371 1.28996 16.1326 2.39453 16.1326H4.88322C5.68569 16.1326 6.45471 15.8111 7.01841 15.2399L13.8891 8.27847C14.4432 7.71703 14.7539 6.95994 14.7539 6.17111V2.58228C14.7539 1.47771 13.8585 0.582275 12.7539 0.582275Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <line
            x1="3.03125"
            y1="4.52271"
            x2="12.3315"
            y2="4.52271"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <line
            x1="3.03125"
            y1="12.5715"
            x2="7.93431"
            y2="12.5715"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <line
            x1="3.03125"
            y1="8.54712"
            x2="10.6793"
            y2="8.54712"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <path
            d="M8.25195 15.1756V16.6359C8.25195 16.7704 8.35763 16.876 8.49213 16.876H9.9524C10.0148 16.876 10.0773 16.852 10.1205 16.804L15.366 11.5634L13.5646 9.76204L8.32401 15.0027C8.27597 15.0507 8.25195 15.1083 8.25195 15.1756ZM17.1583 9.77092C17.3456 9.58358 17.3456 9.28096 17.1583 9.09363L16.0342 7.9696C15.8469 7.78227 15.5443 7.78227 15.3569 7.9696L14.0786 9.24806L15.8799 11.0494L17.1583 9.77092Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    Filled9: {
      viewBox: '0 0 18 17',
      path: (
        <>
          <rect
            x="1.99414"
            y="1.37549"
            width="14.9328"
            height="14.5441"
            rx="2"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <line
            x1="0.994141"
            y1="7.4458"
            x2="17.9277"
            y2="7.4458"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <circle
            cx="5.09555"
            cy="4.50815"
            r="0.997894"
            fill={props.svgFill ? props.svgFill : 'white'}
          />
          <circle
            cx="7.77914"
            cy="4.50815"
            r="0.997894"
            fill={props.svgFill ? props.svgFill : 'white'}
          />
          <circle
            cx="10.4608"
            cy="4.50815"
            r="0.997894"
            fill={props.svgFill ? props.svgFill : 'white'}
          />
        </>
      ),
    },
    Filled10: {
      viewBox: '0 0 25 25',
      path: (
        <>
          <path
            d="M12.311 8.66549L13.6001 3.44373L14.8892 8.66549C14.9916 9.08019 15.3154 9.40398 15.7301 9.50635L20.9518 10.7954L15.7301 12.0845C15.3154 12.1869 14.9916 12.5107 14.8892 12.9254L13.6001 18.1471L12.311 12.9254C12.2087 12.5107 11.8849 12.1869 11.4702 12.0845L6.24842 10.7954L11.4702 9.50635C11.8849 9.40398 12.2087 9.08019 12.311 8.66549Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.5"
          />
          <path
            d="M5.66055 17.2222L6.38049 14.3059L7.10043 17.2222C7.18055 17.5468 7.43395 17.8002 7.7585 17.8803L10.6748 18.6002L7.7585 19.3202C7.43395 19.4003 7.18055 19.6537 7.10043 19.9782L6.38049 22.8945L5.66055 19.9782C5.58043 19.6537 5.32703 19.4003 5.00249 19.3202L2.08619 18.6002L5.00249 17.8803C5.32703 17.8002 5.58043 17.5468 5.66055 17.2222Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
          />
        </>
      ),
    },
    Filled11: {
      viewBox: '0 0 19 17',
      path: (
        <>
          <path
            d="M9.96799 15.4123L7.80469 15.7184L8.08301 13.3391L15.8127 4.8373C16.3314 4.2668 17.179 4.2668 17.6977 4.8373C18.2164 5.40779 18.2164 6.34006 17.6977 6.91056L9.96799 15.4123Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.2969 5.38306L17.4718 8.27713"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M8.66977 12.1421H1.67383"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.0974 6.96558H3.51953"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.9458 1.77588H1.67383"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled12: {
      viewBox: '0 0 20 18',
      path: (
        <>
          <path
            d="M5.88068 16.6446H3.79727V14.5525L12.6629 5.68691L14.7547 7.77873L5.88068 16.6446ZM16.897 5.63695L14.8049 3.54486L16.5416 1.80794C16.5523 1.79729 16.5675 1.79729 16.5782 1.80794L18.6337 3.8635C18.6444 3.87415 18.6444 3.88938 18.6337 3.90003L18.6337 3.90006L16.897 5.63695Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
          />
          <line
            x1="4.40234"
            y1="1.42603"
            x2="4.40234"
            y2="6.98022"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="7.22852"
            y1="4.22119"
            x2="1.67432"
            y2="4.22119"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled13: {
      viewBox: '0 0 16 18',
      path: (
        <>
          <rect
            x="1.58203"
            y="1.22925"
            width="13"
            height="15"
            rx="2"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <line
            x1="5.32227"
            y1="0.229248"
            x2="5.32227"
            y2="17.2292"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <path
            d="M8.13867 0.208008V5.62489C8.13867 5.89216 8.46181 6.02601 8.6508 5.83702L10.0084 4.47939C10.1256 4.36223 10.3155 4.36223 10.4327 4.47939L11.7903 5.83702C11.9793 6.02601 12.3025 5.89216 12.3025 5.62489V0.208008"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.4"
          />
        </>
      ),
    },
    Filled14: {
      viewBox: '0 0 20 20',
      path: (
        <>
          <path
            d="M8.53102 8.98C10.4585 8.98 12.021 7.41747 12.021 5.49C12.021 3.56253 10.4585 2 8.53102 2C6.60354 2 5.04102 3.56253 5.04102 5.49C5.04102 7.41747 6.60354 8.98 8.53102 8.98Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.53186 10.6567C2.19712 11.9484 0.636719 14.333 0.636719 17.0599C5.23194 20.5666 11.5567 20.7538 16.4285 17.0599C16.4285 14.333 14.8681 11.9484 12.5333 10.6567"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M14.7539 3.4519C15.8765 4.57455 15.8765 6.40709 14.7539 7.52973"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.1211 1.4458C19.3581 3.68283 19.3581 7.30665 17.1211 9.54368"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled15: {
      viewBox: '0 0 28 28',
      path: (
        <>
          <path
            d="M9.23281 6.93423C10.8366 7.55172 12.6429 6.80351 13.3404 5.23282C13.7717 4.2615 15.1502 4.26149 15.5815 5.23282C16.2789 6.80351 18.0853 7.55172 19.6891 6.93423C20.6809 6.55238 21.6556 7.52713 21.2738 8.51894C20.6563 10.1228 21.4045 11.9291 22.9752 12.6265C23.9465 13.0578 23.9465 14.4363 22.9752 14.8676C21.4045 15.5651 20.6563 17.3714 21.2738 18.9752C21.6556 19.967 20.6809 20.9418 19.6891 20.5599C18.0853 19.9424 16.2789 20.6906 15.5815 22.2613C15.1502 23.2326 13.7717 23.2326 13.3404 22.2613C12.6429 20.6906 10.8366 19.9424 9.23281 20.5599C8.241 20.9418 7.26625 19.967 7.6481 18.9752C8.26558 17.3714 7.51738 15.5651 5.94669 14.8676C4.97536 14.4363 4.97536 13.0578 5.94669 12.6265C7.51738 11.9291 8.26558 10.1228 7.6481 8.51894C7.26625 7.52713 8.241 6.55238 9.23281 6.93423Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <circle
            cx="14.4615"
            cy="13.7471"
            r="3.58064"
            fill={props.svgFill ? props.svgFill : 'white'}
          />
        </>
      ),
    },
    Filled16: {
      viewBox: '0 0 16 18',
      path: (
        <>
          <path
            d="M0.296875 3.55786C0.296875 1.90101 1.64002 0.557861 3.29688 0.557861H10.1523C10.8941 0.557861 11.6095 0.832672 12.1606 1.32924L13.2306 2.29349L14.3172 3.28328C14.9412 3.85177 15.2969 4.65687 15.2969 5.50104V14.5579C15.2969 16.2147 13.9537 17.5579 12.2969 17.5579H3.29687C1.64002 17.5579 0.296875 16.2147 0.296875 14.5579V3.55786Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M8.86328 0.553467V5.16283C8.86328 6.2674 9.75871 7.16283 10.8633 7.16283H15.2969"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled17: {
      viewBox: '0 0 20 20',
      path: (
        <>
          <path
            d="M1.14844 3.76806C1.14844 2.37717 2.22912 1.24707 3.5592 1.24707H15.7585C17.0678 1.24707 18.1484 2.35543 18.1484 3.74632V12.2655C18.1484 13.6347 17.0885 14.743 15.7792 14.743H14.5739V17.5031C14.5739 18.1551 13.8049 18.5028 13.3685 18.0247L10.2096 14.7213H3.5592C2.24991 14.7213 1.16922 13.6129 1.16922 12.2221V3.72459L1.14844 3.76806Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.14844 6.24707H13.1484"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M6.14844 10.2471H10.1484"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled18: {
      viewBox: '0 0 20 17',
      path: (
        <>
          <rect
            x="1.05664"
            y="4.8645"
            width="17"
            height="10.2941"
            rx="2"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M5.05664 4.33521V4.33521C5.05664 2.67835 6.39979 1.33521 8.05664 1.33521H9.55664H11.0566C12.7135 1.33521 14.0566 2.67835 14.0566 4.33521V4.33521"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M1.05664 8.83521L8.82114 10.6719C9.27526 10.7793 9.74818 10.7793 10.2023 10.6719L17.9668 8.83521"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <rect
            x="1.05664"
            y="4.8645"
            width="17"
            height="10.2941"
            rx="2"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled19: {
      viewBox: '0 0 22 21',
      path: (
        <>
          <path
            d="M7.95508 5.24976H13.9553"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M7.95508 17.2488H13.9553"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M16.9551 13.6467L16.9551 7.64648"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M4.95508 13.6467L4.95508 7.64648"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <rect
            x="1.95508"
            y="1.64795"
            width="6.00024"
            height="6.00024"
            rx="1"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <rect
            x="1.95508"
            y="13.647"
            width="6.00024"
            height="6.00024"
            rx="1"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <rect
            x="14.1562"
            y="13.647"
            width="6.00024"
            height="6.00024"
            rx="1"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <rect
            x="14.1562"
            y="1.64795"
            width="6.00024"
            height="6.00024"
            rx="1"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled20: {
      viewBox: '0 0 19 20',
      path: (
        <>
          <path
            d="M1.18164 6.54175V18.2292H12.8691"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="5.18164"
            y="1.22925"
            width="12.75"
            height="12.75"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.18164 7.5065L10.358 9.68299L14.8115 5.22925"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled21: {
      viewBox: '0 0 33 32',
      path: (
        <>
          <circle
            cx="14.834"
            cy="14.335"
            r="9"
            transform="rotate(45 14.834 14.335)"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M21.2969 20.906L25.2969 24.906"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="square"
          />
          <path
            d="M9.83398 16.2208V16.0208C9.83398 14.9162 10.7294 14.0208 11.834 14.0208H14.8626"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="square"
          />
          <circle
            cx="17.6917"
            cy="14.3357"
            r="2.14286"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled22: {
      viewBox: '0 0 16 22',
      path: (
        <>
          <path
            d="M12.0683 1.25366H3.73341C2.47512 1.25366 1.45508 2.28393 1.45508 3.55484V18.3655C1.45508 19.6364 2.47512 20.6667 3.73341 20.6667H12.0683C13.3266 20.6667 14.3466 19.6364 14.3466 18.3655V3.55484C14.3466 2.28393 13.3266 1.25366 12.0683 1.25366Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.86719 3.43994H9.93654"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.5915 5.36377H4.20591C3.90881 5.36377 3.66797 5.60703 3.66797 5.9071V17.8413C3.66797 18.1413 3.90881 18.3846 4.20591 18.3846H11.5915C11.8886 18.3846 12.1294 18.1413 12.1294 17.8413V5.9071C12.1294 5.60703 11.8886 5.36377 11.5915 5.36377Z"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M3.66797 7.48608H12.1294"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.86719 7.56267V5.36377"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled23: {
      viewBox: '0 0 22 17',
      path: (
        <>
          <path
            d="M19.282 1.64771H9.6951C9.00162 1.64771 8.43945 2.20988 8.43945 2.90335V5.08469C8.43945 5.77816 9.00162 6.34033 9.6951 6.34033H19.282C19.9755 6.34033 20.5376 5.77816 20.5376 5.08469V2.90335C20.5376 2.20988 19.9755 1.64771 19.282 1.64771Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.90039 9.64771H15.9004"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M8.90039 12.6477H20.9004"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M8.90039 15.6477H15.9004"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M5.68009 3.99414H0.900391"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.53906 1.854L5.67916 3.9941L3.53906 6.13419"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled24: {
      viewBox: '0 0 21 21',
      path: (
        <>
          <path
            d="M8.097 14.2374C11.584 14.2374 14.4108 11.4107 14.4108 7.92366C14.4108 4.43664 11.584 1.60986 8.097 1.60986C4.60998 1.60986 1.7832 4.43664 1.7832 7.92366C1.7832 11.4107 4.60998 14.2374 8.097 14.2374Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.6699 12.4963L14.4521 14.2785"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.3262 17.3945L15.3301 13.3984L13.5725 15.156L17.5686 19.1521C17.95 19.5335 18.5718 19.5335 18.9531 19.1521L19.3262 18.779C19.7076 18.3977 19.7076 17.7759 19.3262 17.3945Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M13.5684 15.1602L13.5725 15.156M13.5725 15.156L17.5686 19.1521C17.95 19.5335 18.5718 19.5335 18.9531 19.1521L19.3262 18.779C19.7076 18.3977 19.7076 17.7759 19.3262 17.3945L15.3301 13.3984L13.5725 15.156Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="square"
          />
          <path
            d="M4.6543 6.55786L6.44819 9.8408L8.10138 6.55786L9.74285 9.83494L11.5367 6.55786"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled25: {
      viewBox: '0 0 24 15',
      path: (
        <>
          <path
            d="M12.6421 7.81148L15.2497 13.1369L22.2832 3.39697"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.64213 7.81148L4.24966 13.1369L11.2832 3.39697"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled26: {
      viewBox: '0 0 27 16',
      path: (
        <>
          <path
            d="M3.71927 3.85494L10.6543 1.58002C10.6666 1.576 10.6732 1.57658 10.6773 1.57727C10.6831 1.57826 10.6911 1.5811 10.6993 1.58704C10.7074 1.59297 10.7126 1.59962 10.7154 1.60485C10.7173 1.60856 10.7199 1.61463 10.7199 1.62753V13.8666C10.7199 13.8795 10.7173 13.8856 10.7154 13.8893C10.7126 13.8945 10.7074 13.9012 10.6993 13.9071C10.6911 13.913 10.6831 13.9159 10.6773 13.9169C10.6732 13.9176 10.6666 13.9181 10.6543 13.9141L3.71927 11.6392C2.46676 11.2283 1.61992 10.0593 1.61992 8.74114V6.753C1.61992 5.43482 2.46675 4.2658 3.71927 3.85494Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.9"
          />
          <path
            d="M11.6699 9.90487C12.9249 9.90487 13.9422 8.88755 13.9422 7.63261C13.9422 6.37768 12.9249 5.36035 11.6699 5.36035"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.9"
          />
          <path
            d="M17.2051 11.3181C19.1577 9.36552 19.1577 6.19969 17.2051 4.24707"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.9"
          />
          <path
            d="M19.6699 14.782C23.5359 10.9161 23.5359 4.64816 19.6699 0.782227"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.9"
          />
        </>
      ),
    },
    Filled27: {
      viewBox: '0 0 17 19',
      path: (
        <>
          <path
            d="M15.181 5.20326L14.4103 15.9962C14.3784 16.4447 14.1777 16.8644 13.8486 17.1709C13.5196 17.4773 13.0866 17.6477 12.637 17.6477H5.28055C4.83089 17.6477 4.39794 17.4773 4.06889 17.1709C3.73984 16.8644 3.53914 16.4447 3.50721 15.9962L2.73655 5.20326M11.6254 5.20326V2.53659C11.6254 2.30085 11.5318 2.07475 11.3651 1.90805C11.1984 1.74136 10.9723 1.64771 10.7365 1.64771H7.18099C6.94524 1.64771 6.71915 1.74136 6.55245 1.90805C6.38575 2.07475 6.2921 2.30085 6.2921 2.53659V5.20326M1.84766 5.20326H16.0699Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M15.181 5.20326L14.4103 15.9962C14.3784 16.4447 14.1777 16.8644 13.8486 17.1709C13.5196 17.4773 13.0866 17.6477 12.637 17.6477H5.28055C4.83089 17.6477 4.39794 17.4773 4.06889 17.1709C3.73984 16.8644 3.53914 16.4447 3.50721 15.9962L2.73655 5.20326M11.6254 5.20326V2.53659C11.6254 2.30085 11.5318 2.07475 11.3651 1.90805C11.1984 1.74136 10.9723 1.64771 10.7365 1.64771H7.18099C6.94524 1.64771 6.71915 1.74136 6.55245 1.90805C6.38575 2.07475 6.2921 2.30085 6.2921 2.53659V5.20326M1.84766 5.20326H16.0699"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.18164 8.75879V14.0921M10.7372 8.75879V14.0921"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.72"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled28: {
      viewBox: '0 0 22 16',
      path: (
        <>
          <path
            d="M0.958984 3.04775V13.068C0.958984 13.5995 1.14045 14.1092 1.46347 14.485C1.78649 14.8609 2.2246 15.072 2.68142 15.072H14.7385C15.1953 15.072 15.6334 14.8609 15.9564 14.485C16.2795 14.1092 16.4609 13.5995 16.4609 13.068V12.2222H14.5477C13.4431 12.2222 12.5477 11.3267 12.5477 10.2222V7.94922C12.5477 6.84465 13.4431 5.94922 14.5477 5.94922H16.4609V5.05179C16.4609 4.52029 16.2795 4.01055 15.9564 3.63472C15.6334 3.25889 15.1953 3.04775 14.7385 3.04775H9.57117L7.84874 1.0437H2.68142C2.2246 1.0437 1.78649 1.25484 1.46347 1.63067C1.14045 2.0065 0.958984 2.51624 0.958984 3.04775Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.72244"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.793 9.08114L20.9603 9.08114M20.9603 9.08114L18.3766 11.6648M20.9603 9.08114L18.3766 6.49748"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.72244"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled29: {
      viewBox: '0 0 19 20',
      path: (
        <>
          <path
            d="M7.64624 4.85156H3.0203C2.52955 4.85156 2.0589 5.04651 1.71188 5.39353C1.36487 5.74054 1.16992 6.21119 1.16992 6.70194V16.879C1.16992 17.3698 1.36487 17.8404 1.71188 18.1874C2.0589 18.5344 2.52955 18.7294 3.0203 18.7294H13.1974C13.6881 18.7294 14.1588 18.5344 14.5058 18.1874C14.8528 17.8404 15.0478 17.3698 15.0478 16.879V12.2531"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.85038"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.9806 3.36884L17.9807 3.36881C17.9902 3.35928 17.9902 3.34566 17.9807 3.33613L16.1415 1.49692C16.1319 1.48741 16.1183 1.4874 16.1088 1.4969L17.9806 3.36884ZM17.9806 3.36884L16.4267 4.92291L14.5548 3.05102L16.1088 1.49693L17.9806 3.36884ZM6.56997 14.7719H4.70584V12.9001L12.6383 4.96761L14.5099 6.83925L6.56997 14.7719Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.52106"
          />
        </>
      ),
    },
    Filled30: {
      viewBox: '0 0 17 16',
      path: (
        <>
          <path
            d="M15.4004 11.0402V4.88021C15.4004 3.84056 14.9874 2.84349 14.2522 2.10835C13.5171 1.3732 12.52 0.960205 11.4804 0.960205H5.32039C4.28074 0.960205 3.28367 1.3732 2.54853 2.10835C1.81339 2.84349 1.40039 3.84056 1.40039 4.88021V11.0402C1.40039 12.0799 1.81339 13.0769 2.54853 13.8121C3.28367 14.5472 4.28074 14.9602 5.32039 14.9602H11.4804C12.52 14.9602 13.5171 14.5472 14.2522 13.8121C14.9874 13.0769 15.4004 12.0799 15.4004 11.0402Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
          />
          <path
            d="M10.2626 9.20469C10.5088 8.83633 10.6402 8.40324 10.6402 7.96021C10.6383 7.3667 10.4017 6.79802 9.98204 6.37833C9.56235 5.95865 8.99367 5.72206 8.40016 5.72021C7.95713 5.72021 7.52405 5.85159 7.15568 6.09772C6.78731 6.34386 6.50021 6.6937 6.33067 7.103C6.16113 7.51231 6.11677 7.9627 6.2032 8.39722C6.28963 8.83173 6.50297 9.23086 6.81624 9.54413C7.12951 9.8574 7.52864 10.0707 7.96316 10.1572C8.39767 10.2436 8.84806 10.1992 9.25737 10.0297C9.66667 9.86016 10.0165 9.57306 10.2626 9.20469Z"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.4"
          />
          <circle
            cx="11.9004"
            cy="4.46021"
            r="0.875"
            fill={props.svgFill ? props.svgFill : 'white'}
          />
        </>
      ),
    },
    Filled31: {
      viewBox: '0 0 17 16',
      path: (
        <>
          <path
            d="M9.43971 10.542V15.2291H6.07812V4.66996H9.27473V6.60854H9.39159C9.62532 5.96235 10.024 5.45593 10.5877 5.0893C11.1514 4.71808 11.8228 4.53247 12.6019 4.53247C13.3444 4.53247 13.9883 4.69975 14.5337 5.0343C15.0836 5.36427 15.5098 5.82715 15.8123 6.42293C16.1194 7.01413 16.2706 7.70616 16.266 8.49901V15.2291H12.9044V10.4939C12.909 9.90724 12.7601 9.44895 12.4576 9.11898C12.1597 8.78901 11.7449 8.62402 11.2133 8.62402C10.8604 8.62402 10.5488 8.70193 10.2784 8.85775C10.0126 9.00899 9.80635 9.22668 9.6597 9.51082C9.51762 9.79496 9.4443 10.1387 9.43971 10.542Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M0.535156 15.2288V4.66968H3.89674V15.2288H0.535156Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <circle
            cx="1.9414"
            cy="1.63574"
            r="1.40625"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    Filled32: {
      viewBox: '0 0 16 16',
      path: (
        <>
          <line
            x1="8.47813"
            y1="14.3827"
            x2="8.47813"
            y2="1.73342"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <line
            x1="14.7242"
            y1="7.94936"
            x2="2.07498"
            y2="7.94936"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled33: {
      viewBox: '0 0 22 22',
      path: (
        <>
          <line
            x1="15.9287"
            y1="15.0637"
            x2="6.98438"
            y2="6.11936"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <line
            x1="15.7949"
            y1="6.09836"
            x2="6.85055"
            y2="15.0427"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled34: {
      viewBox: '0 0 18 19',
      path: (
        <>
          <path
            d="M14.0923 17.8804H3.97461C2.87004 17.8804 1.97461 16.985 1.97461 15.8804V3.61377C1.97461 2.5092 2.87004 1.61377 3.97461 1.61377H11.6502C12.1447 1.61377 12.6217 1.79698 12.9891 2.12802L14.2007 3.21982L14.2026 3.22159L15.4391 4.34801C15.8552 4.727 16.0923 5.26374 16.0923 5.82651V15.8804C16.0923 16.985 15.1968 17.8804 14.0923 17.8804Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M10.1777 0.61377V5.71089C10.1777 6.81545 11.0732 7.71089 12.1777 7.71089H17.0938"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <path
            d="M4.19727 5.92457L9.51098 5.92456"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <path
            d="M4.19727 14.5725L13.8679 14.5725"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <line
            x1="4.19727"
            y1="10.3232"
            x2="11.6021"
            y2="10.3232"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled35: {
      viewBox: '0 0 14 14',
      path: (
        <>
          <line
            x1="0.628906"
            y1="1.22925"
            x2="13.3392"
            y2="1.22925"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <line
            x1="0.628906"
            y1="12.2292"
            x2="7.32972"
            y2="12.2292"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <line
            x1="0.628906"
            y1="6.72925"
            x2="11.0812"
            y2="6.72925"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled36: {
      viewBox: '0 0 23 19',
      path: (
        <>
          <path
            d="M1.5332 2.9923V12.3837C1.5332 12.8819 1.73109 13.3596 2.08334 13.7119C2.43559 14.0641 2.91334 14.262 3.41149 14.262H9.92463L18.4378 5.56642V4.87059C18.4378 4.37243 18.2399 3.89468 17.8876 3.54244C17.5354 3.19019 17.0576 2.9923 16.5595 2.9923H10.9246L9.04635 1.11401H3.41149C2.91334 1.11401 2.43559 1.3119 2.08334 1.66415C1.73109 2.0164 1.5332 2.49415 1.5332 2.9923Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="17.8388"
            y1="17.4199"
            x2="17.8388"
            y2="10.2525"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
          />
          <line
            x1="14.3057"
            y1="13.7856"
            x2="21.473"
            y2="13.7856"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled37: {
      viewBox: '0 0 21 23',
      path: (
        <>
          <path
            d="M1.44141 2.69727V16.2968C1.44141 17.1252 2.11298 17.7968 2.94141 17.7968H5.59909C6.34888 17.7968 7.0715 17.516 7.62459 17.0098L15.7632 9.56069C15.9702 9.37126 16.0881 9.10359 16.0881 8.82303V5.39258C16.0881 4.9705 15.9102 4.56795 15.5982 4.2837L14.0705 2.89201L12.6178 1.58295C12.3423 1.33467 11.9846 1.19727 11.6137 1.19727H2.94141C2.11298 1.19727 1.44141 1.86884 1.44141 2.69727Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
          />
          <path
            d="M9.80469 0.238525V5.64636C9.80469 6.75093 10.7001 7.64636 11.8047 7.64636L17.0457 7.64636"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.92"
          />
          <line
            x1="15.9306"
            y1="21.1386"
            x2="15.9306"
            y2="13.9713"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
          />
          <line
            x1="12.3975"
            y1="17.5044"
            x2="19.5648"
            y2="17.5044"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled38: {
      viewBox: '0 0 17 18',
      path: (
        <>
          <circle
            cx="8.67509"
            cy="8.96025"
            r="2.52665"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <line
            x1="8.92969"
            y1="3.69971"
            x2="8.92969"
            y2="1.75817"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="8.92969"
            y1="16.1624"
            x2="8.92969"
            y2="14.2208"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="13.9355"
            y1="8.98071"
            x2="15.8771"
            y2="8.98071"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="1.47266"
            y1="8.98071"
            x2="3.41419"
            y2="8.98071"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="4.85336"
            y1="5.07666"
            x2="3.48049"
            y2="3.70379"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="13.8495"
            y1="14.0376"
            x2="12.4766"
            y2="12.6647"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="4.87305"
            y1="12.518"
            x2="3.50017"
            y2="13.8908"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="13.9883"
            y1="3.61416"
            x2="12.6154"
            y2="4.98704"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled39: {
      viewBox: '0 0 21 14',
      path: (
        <>
          <path
            d="M10.6738 8.72925C8.46469 8.72925 6.67383 10.5201 6.67383 12.7292H14.6738C14.6738 10.5201 12.883 8.72925 10.6738 8.72925Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <line
            x1="10.6738"
            y1="5.28491"
            x2="10.6738"
            y2="1.72904"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="5.18735"
            y1="7.65796"
            x2="2.67297"
            y2="5.14358"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="18.6016"
            y1="5.14346"
            x2="16.0872"
            y2="7.65784"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M1.67383 12.7292L19.6738 12.7292"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled40: {
      viewBox: '0 0 23 20',
      path: (
        <>
          <path
            d="M3.83452 5.98022C2.12585 9.19546 2.62804 13.262 5.33496 15.9689C8.04189 18.6758 12.1145 19.178 15.3236 17.4693"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.37109 2.44686C10.5802 0.744314 14.6528 1.2465 17.3536 3.9473C20.0544 6.64811 20.5566 10.7207 18.8602 13.9237"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.834 13.8689L18.8462 13.8628L18.8646 13.9179L18.9197 13.8934L18.9258 13.9057L18.8585 13.9363L18.834 13.8689Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M21.3416 12.809L18.8612 13.9359L17.7344 11.4556"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.34961 7.10709L3.83606 5.98022L4.9568 8.46668"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.4712 9.30005C13.0409 9.30005 14.3135 8.02751 14.3135 6.45776C14.3135 4.88801 13.0409 3.61548 11.4712 3.61548C9.90144 3.61548 8.62891 4.88801 8.62891 6.45776C8.62891 8.02751 9.90144 9.30005 11.4712 9.30005Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M8.75522 9.97705C7.16931 10.8544 6.10938 12.4742 6.10938 14.3265C9.23076 16.7085 13.527 16.8357 16.8362 14.3265C16.8362 12.4742 15.7763 10.8544 14.1904 9.97705"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    Filled41: {
      viewBox: '0 0 17 20',
      path: (
        <>
          <path
            d="M11.6345 16.2805L8.34877 18.2292L5.06309 16.2805C2.53996 14.7835 0.998047 12.1217 0.998047 9.2475V4.60965C2.92124 4.60965 4.47997 3.09636 4.47997 1.22925H12.212C12.212 3.09636 13.7707 4.60965 15.6939 4.60965V9.24206C15.6939 12.1162 14.152 14.7781 11.6288 16.275L11.6345 16.2805Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.35573 8.1153C9.18322 8.1153 9.85404 7.46405 9.85404 6.66068C9.85404 5.85731 9.18322 5.20605 8.35573 5.20605C7.52824 5.20605 6.85742 5.85731 6.85742 6.66068C6.85742 7.46405 7.52824 8.1153 8.35573 8.1153Z"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.88822 9.2998C6.03388 9.78746 5.46289 10.6877 5.46289 11.7172C7.20162 12.8843 9.50274 12.8843 11.2415 11.7172C11.2415 10.6877 10.6705 9.78746 9.81614 9.2998"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled42: {
      viewBox: '0 0 17 15',
      path: (
        <>
          <path
            d="M8.34586 1.48779L15.1859 13.3278H1.50586L8.34586 1.48779Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.3418 6.21826V9.01826"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.34305 11.5284C8.74069 11.5284 9.06305 11.206 9.06305 10.8084C9.06305 10.4107 8.74069 10.0884 8.34305 10.0884C7.9454 10.0884 7.62305 10.4107 7.62305 10.8084C7.62305 11.206 7.9454 11.5284 8.34305 11.5284Z"
            fill={props.svgFill ? props.svgFill : 'white'}
          />
        </>
      ),
    },
    Filled43: {
      viewBox: '0 0 15 15',
      path: (
        <>
          <path
            d="M11.1063 7.3248L12.6303 5.80077C13.4114 5.01973 13.4114 3.7534 12.6303 2.97235L12.1388 2.48086C11.3578 1.69982 10.0914 1.69981 9.3104 2.48086L6.30921 5.48205C5.52816 6.2631 5.52816 7.52943 6.30921 8.31048L6.42281 8.42408"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M3.58512 8.20596L2.0611 9.72999C1.28005 10.511 1.28005 11.7774 2.0611 12.5584L2.55258 13.0499C3.33363 13.8309 4.59996 13.8309 5.38101 13.0499L8.3822 10.0487C9.16325 9.26766 9.16325 8.00133 8.3822 7.22028L8.2686 7.10668"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled44: {
      viewBox: '0 0 22 22',
      path: (
        <>
          <path
            d="M9.58789 1.28418H16.0789C16.5664 1.28418 17.0371 1.46224 17.4026 1.78489L18.4091 2.67355L18.4111 2.67528L19.3992 3.55721C19.8244 3.93667 20.0675 4.47948 20.0675 5.04935V13.3618C20.0675 14.4664 19.172 15.3618 18.0675 15.3618H15.6778C15.3646 15.3618 15.0695 15.2151 14.8805 14.9653L7.79055 5.59855C7.65905 5.42483 7.58789 5.21291 7.58789 4.99503V3.28418C7.58789 2.17961 8.48332 1.28418 9.58789 1.28418Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M15.3105 0.28125V4.41025C15.3105 5.51482 16.206 6.41025 17.3105 6.41025H21.0774"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <path
            d="M12.9375 20.3179H3.9375C2.83293 20.3179 1.9375 19.4224 1.9375 18.3179V7.31787C1.9375 6.2133 2.83293 5.31787 3.9375 5.31787H10.7929C11.2874 5.31787 11.7644 5.50108 12.1318 5.83212L13.1978 6.79275L13.1998 6.79452L14.2844 7.78254C14.7004 8.16153 14.9375 8.69827 14.9375 9.26105V18.3179C14.9375 19.4224 14.0421 20.3179 12.9375 20.3179Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <path
            d="M9.50195 4.31787V8.92285C9.50195 10.0274 10.3974 10.9229 11.502 10.9229H15.6875"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
        </>
      ),
    },
    Filled45: {
      viewBox: '0 0 22 23',
      path: (
        <>
          <path
            d="M9.58789 2.00146H16.0789C16.5664 2.00146 17.0371 2.17953 17.4026 2.50218L18.4091 3.39083L18.4111 3.39257L19.3992 4.2745C19.8244 4.65396 20.0675 5.19677 20.0675 5.76664V14.0791C20.0675 15.1837 19.172 16.0791 18.0675 16.0791H15.6778C15.3646 16.0791 15.0695 15.9324 14.8805 15.6826L7.79055 6.31584C7.65905 6.14211 7.58789 5.93019 7.58789 5.71231V4.00146C7.58789 2.89689 8.48332 2.00146 9.58789 2.00146Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M15.3105 0.998535V5.12754C15.3105 6.23211 16.206 7.12754 17.3105 7.12754H21.0774"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <path
            d="M12.9375 21.0352H3.9375C2.83293 21.0352 1.9375 20.1397 1.9375 19.0352V8.03516C1.9375 6.93059 2.83293 6.03516 3.9375 6.03516H10.7929C11.2874 6.03516 11.7644 6.21836 12.1318 6.54941L13.1978 7.51004L13.1998 7.51181L14.2844 8.49983C14.7004 8.87882 14.9375 9.41555 14.9375 9.97833V19.0352C14.9375 20.1397 14.0421 21.0352 12.9375 21.0352Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
          />
          <line
            x1="8.39063"
            y1="11.2332"
            x2="8.39062"
            y2="16.7874"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <line
            x1="11.2168"
            y1="14.0283"
            x2="5.66257"
            y2="14.0283"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled46: {
      viewBox: '0 0 16 20',
      path: (
        <>
          <path
            d="M7.9568 8.39211C9.88427 8.39211 11.4468 6.82958 11.4468 4.90211C11.4468 2.97464 9.88427 1.41211 7.9568 1.41211C6.02932 1.41211 4.4668 2.97464 4.4668 4.90211C4.4668 6.82958 6.02932 8.39211 7.9568 8.39211Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.95764 10.0688C1.6229 11.3605 0.0625 13.7451 0.0625 16.472C4.65772 19.9787 10.9825 20.1659 15.8542 16.472C15.8542 13.7451 14.2938 11.3605 11.9591 10.0688"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    Filled47: {
      viewBox: '0 0 21 16',
      path: (
        <>
          <path
            d="M6.42738 1.05273H14.9214C15.9227 1.05273 16.7433 1.85026 16.7433 2.84113V8.93942H4.60547V2.84113C4.60547 1.85832 5.41794 1.05273 6.42738 1.05273Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M3.05343 7.67456C3.91515 7.67456 4.61273 8.35931 4.61273 9.20517V14.4495H1.49414V9.20517C1.49414 8.35931 2.19172 7.67456 3.05343 7.67456Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M18.2933 7.67456C19.155 7.67456 19.8526 8.35931 19.8526 9.20517V14.4495H16.7422V9.20517C16.7422 8.35931 17.4398 7.67456 18.3015 7.67456H18.2933Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M4.60547 14.4414H16.7433"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled48: {
      viewBox: '0 0 17 17',
      path: (
        <>
          <path
            d="M15.6183 8.64751C15.6183 9.55952 15.4386 10.4626 15.0896 11.3052C14.7406 12.1478 14.229 12.9134 13.5841 13.5583C12.9393 14.2032 12.1737 14.7147 11.3311 15.0637C10.4885 15.4127 9.5854 15.5924 8.67339 15.5924C7.76137 15.5924 6.85829 15.4127 6.0157 15.0637C5.17311 14.7147 4.40751 14.2032 3.76262 13.5583C3.11773 12.9134 2.60617 12.1478 2.25716 11.3052C1.90815 10.4626 1.72852 9.55952 1.72852 8.64751C1.72852 6.80561 2.4602 5.03916 3.76262 3.73674C5.06504 2.43433 6.83149 1.70264 8.67339 1.70264C10.5153 1.70264 12.2817 2.43433 13.5841 3.73674C14.8866 5.03916 15.6183 6.80561 15.6183 8.64751Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.5433"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.35938 8.64755L7.90268 10.1909L10.9893 7.10425"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="1.5433"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled49: {
      viewBox: '0 0 22 18',
      path: (
        <>
          <circle
            cx="9.29431"
            cy="9.17957"
            r="8.70837"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M10.8926 5.76294C9.81217 5.25647 8.51786 5.26772 7.41487 5.90925C5.60283 6.94471 4.98381 9.25196 6.03052 11.064C7.07723 12.8648 9.38448 13.4838 11.1853 12.4484C12.2432 11.8406 12.896 10.7826 13.0423 9.64589"
            stroke={props.stroke ? props.stroke : 'white'}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M17.1196 5.63956C17.5261 5.40472 17.6652 4.88482 17.4304 4.47834C17.1955 4.07187 16.6756 3.93273 16.2692 4.16757L17.1196 5.63956ZM8.80916 8.47757L8.07316 8.90279L8.9236 10.3748L9.65959 9.94956L8.80916 8.47757ZM16.2692 4.16757L8.80916 8.47757L9.65959 9.94956L17.1196 5.63956L16.2692 4.16757Z"
            fill={props.svgFill ? props.svgFill : 'white'}
          />
          <path
            d="M19.3987 1.18083C19.5211 1.11018 19.6762 1.18535 19.6966 1.32521L19.9326 2.94477C19.94 2.9953 19.9664 3.0411 20.0064 3.07278L21.293 4.09065C21.4038 4.17831 21.3913 4.3501 21.2689 4.42072L18.4017 6.07558C18.3307 6.11655 18.2419 6.11006 18.1776 6.05921L16.7664 4.94278C16.7264 4.9111 16.7 4.8653 16.6926 4.81477L16.4336 3.03769C16.4218 2.95664 16.4606 2.87658 16.5316 2.83563L19.3987 1.18083Z"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    Filled50: {
      viewBox: '0 0 14 10',
      path: (
        <>
          <path
            d="M1.77344 4.71592L5.47407 8.41656L12.1914 1.69922"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      ),
    },
    Filled51: {
      viewBox: '0 0 19 19',
      path: (
        <>
          <path
            d="M1.05664 3.5013L11.7637 3.5013M6.41016 1.7168L6.41016 3.5013M7.34524 11.9777C5.97126 10.5553 4.87145 8.89169 4.10101 7.07031M9.53304 15.1006L15.7788 15.1006M8.19466 17.7773L12.6559 8.85482L17.1172 17.7773M9.757 3.5013C8.8933 8.6496 5.58036 12.9681 1.05664 15.2157"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled52: {
      viewBox: '0 0 19 17',
      path: (
        <>
          <path
            d="M18.0361 6.21654L11.6826 1.26078C11.3649 1.01935 10.9456 0.968517 10.5898 1.14642C10.234 1.32432 10.0053 1.68011 10.0053 2.07403V3.67512C7.85777 3.48452 5.73569 4.11987 4.08377 5.49224C2.21583 7.02979 1.14844 9.30436 1.14844 11.7314C1.14844 13.0911 1.49153 14.4253 2.13959 15.6071C2.35561 16.0137 2.76224 16.2551 3.21969 16.2551C3.25781 16.2551 3.29593 16.2551 3.34676 16.2551C3.85504 16.2043 4.26167 15.8739 4.41416 15.391C5.24011 12.7988 7.41302 10.9436 10.018 10.4861V11.9855C10.018 12.3795 10.2467 12.748 10.6025 12.9132C10.7423 12.9894 10.9075 13.0148 11.06 13.0148C11.2887 13.0148 11.5047 12.9386 11.6953 12.7988L14.0969 10.9309L14.8721 10.3336L16.0792 9.39331L16.8036 8.8342L18.0488 7.86846C18.303 7.66515 18.4428 7.37288 18.4428 7.05521C18.4428 6.73753 18.303 6.43256 18.0488 6.24195L18.0361 6.21654Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeMiterlimit="10"
          />
        </>
      ),
    },
    Filled53: {
      viewBox: '0 0 19 18',
      path: (
        <>
          <path
            d="M8.25113 2.43886C8.50661 1.70983 9.61628 1.70983 9.87092 2.43886L11.1645 6.1386C11.2202 6.2973 11.3284 6.43558 11.4737 6.53367C11.619 6.63176 11.794 6.68465 11.9736 6.68477H16.1593C16.9846 6.68477 17.3269 7.66631 16.6601 8.11749L13.274 10.4035C13.1286 10.5018 13.0203 10.6403 12.9648 10.7993C12.9093 10.9583 12.9093 11.1295 12.9649 11.2885L14.2576 14.9882C14.5131 15.718 13.6147 16.3244 12.9478 15.8732L9.56178 13.5872C9.41625 13.4888 9.24095 13.4359 9.06102 13.4359C8.8811 13.4359 8.7058 13.4888 8.56027 13.5872L5.1742 15.8732C4.50737 16.3244 3.60891 15.7172 3.8644 14.9882L5.15717 11.2885C5.21276 11.1295 5.21279 10.9583 5.15726 10.7993C5.10172 10.6403 4.99348 10.5018 4.84802 10.4035L1.46196 8.11749C0.794281 7.66631 1.13834 6.68477 1.96271 6.68477H6.14761C6.32734 6.68482 6.50248 6.63201 6.64796 6.5339C6.79343 6.4358 6.90179 6.29743 6.9575 6.1386L8.25113 2.43886Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled54: {
      viewBox: '0 0 21 21',
      path: (
        <>
          <path
            d="M12.2087 8.72925H17.036C17.3814 8.72926 17.721 8.81639 18.0227 8.98237C18.3244 9.14835 18.5781 9.38767 18.7597 9.67761C18.9413 9.96755 19.0449 10.2985 19.0604 10.639C19.076 10.9795 19.0032 11.3183 18.8488 11.6232L15.3023 18.6232C15.1339 18.9557 14.875 19.2353 14.5546 19.4307C14.2343 19.626 13.8651 19.7294 13.4885 19.7292H9.41808C9.25292 19.7292 9.08775 19.7092 8.92664 19.6692L5.11566 18.7292M12.2087 8.72925V3.72925C12.2087 3.19882 11.9952 2.69011 11.6151 2.31503C11.2351 1.93996 10.7196 1.72925 10.1821 1.72925H10.0858C9.57919 1.72925 9.16881 2.13425 9.16881 2.63425C9.16881 3.34825 8.95501 4.04625 8.55273 4.64025L5.11566 9.72925V18.7292M12.2087 8.72925H10.1821ZM5.11566 18.7292H3.08908C2.5516 18.7292 2.03613 18.5185 1.65607 18.1435C1.27601 17.7684 1.0625 17.2597 1.0625 16.7292V10.7292C1.0625 10.1988 1.27601 9.69011 1.65607 9.31503C2.03613 8.93996 2.5516 8.72925 3.08908 8.72925H5.6223"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M12.2087 8.72925H17.036C17.3814 8.72926 17.721 8.81639 18.0227 8.98237C18.3244 9.14835 18.5781 9.38767 18.7597 9.67761C18.9413 9.96755 19.0449 10.2985 19.0604 10.639C19.076 10.9795 19.0032 11.3183 18.8488 11.6232L15.3023 18.6232C15.1339 18.9557 14.875 19.2353 14.5546 19.4307C14.2343 19.626 13.8651 19.7294 13.4885 19.7292H9.41808C9.25292 19.7292 9.08775 19.7092 8.92664 19.6692L5.11566 18.7292M12.2087 8.72925V3.72925C12.2087 3.19882 11.9952 2.69011 11.6151 2.31503C11.2351 1.93996 10.7196 1.72925 10.1821 1.72925H10.0858C9.57919 1.72925 9.16881 2.13425 9.16881 2.63425C9.16881 3.34825 8.95501 4.04625 8.55273 4.64025L5.11566 9.72925V18.7292M12.2087 8.72925H10.1821M5.11566 18.7292H3.08908C2.5516 18.7292 2.03613 18.5185 1.65607 18.1435C1.27601 17.7684 1.0625 17.2597 1.0625 16.7292V10.7292C1.0625 10.1988 1.27601 9.69011 1.65607 9.31503C2.03613 8.93996 2.5516 8.72925 3.08908 8.72925H5.6223"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled55: {
      viewBox: '0 0 21 21',
      path: (
        <>
          <path
            d="M7.91632 12.0579H3.08901C2.74361 12.0578 2.40395 11.9707 2.10227 11.8047C1.80058 11.6388 1.54689 11.3994 1.36528 11.1095C1.18366 10.8196 1.08015 10.4886 1.06456 10.1481C1.04898 9.80758 1.12184 9.46878 1.27624 9.16386L4.82275 2.16386C4.99101 1.83155 5.24974 1.55205 5.56992 1.3567C5.8901 1.16135 6.25909 1.05787 6.63552 1.05786H10.7069C10.8726 1.05796 11.0376 1.07811 11.1984 1.11786L15.0083 2.05786M7.91531 12.0579V17.0579C7.91531 17.5883 8.12882 18.097 8.50888 18.4721C8.88893 18.8471 9.4044 19.0579 9.94188 19.0579H10.0392C10.5458 19.0579 10.9562 18.6529 10.9562 18.1539C10.9562 17.4389 11.17 16.7409 11.5723 16.1459L15.0093 11.0579L15.0083 2.05786M7.91632 12.0579H9.9429ZM15.0083 2.05786H17.0359C17.5734 2.05786 18.0889 2.26857 18.4689 2.64365C18.849 3.01872 19.0625 3.52743 19.0625 4.05786V10.0579C19.0625 10.5883 18.849 11.097 18.4689 11.4721C18.0889 11.8471 17.5734 12.0579 17.0359 12.0579H14.5027"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
          <path
            d="M15.0083 2.05786L11.1984 1.11786C11.0376 1.07811 10.8726 1.05796 10.7069 1.05786H6.63552C6.25909 1.05787 5.8901 1.16135 5.56992 1.3567C5.24974 1.55205 4.99101 1.83155 4.82275 2.16386L1.27624 9.16386C1.12184 9.46878 1.04898 9.80758 1.06456 10.1481C1.08015 10.4886 1.18366 10.8196 1.36528 11.1095C1.54689 11.3994 1.80058 11.6388 2.10227 11.8047C2.40395 11.9707 2.74361 12.0578 3.08901 12.0579H7.91632H9.9429M15.0083 2.05786L15.0093 11.0579L11.5723 16.1459C11.17 16.7409 10.9562 17.4389 10.9562 18.1539C10.9562 18.6529 10.5458 19.0579 10.0392 19.0579H9.94188C9.4044 19.0579 8.88893 18.8471 8.50888 18.4721C8.12882 18.097 7.91531 17.5883 7.91531 17.0579V12.0579M15.0083 2.05786H17.0359C17.5734 2.05786 18.0889 2.26857 18.4689 2.64365C18.849 3.01872 19.0625 3.52743 19.0625 4.05786V10.0579C19.0625 10.5883 18.849 11.097 18.4689 11.4721C18.0889 11.8471 17.5734 12.0579 17.0359 12.0579H14.5027"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled56: {
      viewBox: '0 0 8 16',
      path: (
        <>
          <path
            d="M2.3125 14.6477C2.3125 14.7858 2.42443 14.8977 2.5625 14.8977H4.8125C4.95057 14.8977 5.0625 14.7858 5.0625 14.6477V7.56995H7.0625C7.20057 7.56995 7.3125 7.45802 7.3125 7.31995V5.09587C7.3125 4.9578 7.20057 4.84587 7.0625 4.84587H5.0625V3.61315C5.0625 3.34619 5.28533 3.12179 5.5625 3.12179H7.0625C7.20057 3.12179 7.3125 3.00986 7.3125 2.87179V0.647705C7.3125 0.509634 7.20057 0.397705 7.0625 0.397705H5.1875C3.60467 0.397705 2.3125 1.67085 2.3125 3.24247V4.84587H1.0625C0.924429 4.84587 0.8125 4.9578 0.8125 5.09587V7.31995C0.8125 7.45802 0.924429 7.56995 1.0625 7.56995H2.3125V14.6477Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="0.5"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled57: {
      viewBox: '0 0 18 15',
      path: (
        <>
          <path
            d="M17.2705 2.91517C17.3324 2.82228 17.3253 2.69959 17.253 2.61454C17.1806 2.52949 17.0607 2.50269 16.9591 2.54888C16.6858 2.67308 16.4019 2.77684 16.1097 2.86006C16.4437 2.49105 16.7019 2.04977 16.8572 1.55965C16.8886 1.46049 16.8554 1.35224 16.7737 1.28783C16.692 1.22342 16.579 1.21631 16.4899 1.26998C15.9191 1.61377 15.2888 1.86184 14.6224 2.01315C13.978 1.36766 13.1024 0.99707 12.1218 0.99707C10.1857 0.99707 8.606 2.57796 8.606 4.52766C8.606 4.69059 8.61717 4.85057 8.63786 5.00602C6.11666 4.79114 3.88115 3.5443 2.37295 1.69327C2.32123 1.6298 2.24171 1.59567 2.16008 1.60192C2.07844 1.60816 2.00504 1.65397 1.96357 1.72457C1.65827 2.24432 1.48554 2.85386 1.48554 3.49531C1.48554 4.39474 1.81835 5.22071 2.37481 5.84136C2.18181 5.7822 1.99629 5.70452 1.81979 5.61324C1.74229 5.57316 1.6495 5.57639 1.57497 5.62175C1.50044 5.66712 1.45495 5.74805 1.45495 5.83531V5.85825C1.45495 7.174 2.17469 8.32454 3.24106 8.93218C3.12958 8.92306 3.01844 8.90764 2.90816 8.88591C2.82143 8.86881 2.73212 8.8988 2.67327 8.96476C2.61442 9.03072 2.59479 9.12286 2.62162 9.20709C2.84522 9.90879 3.28313 10.5228 3.87378 10.9627C4.28298 11.2675 4.75123 11.4782 5.24517 11.5834C4.23333 12.2289 3.05303 12.5729 1.84382 12.5671H1.84261C1.5924 12.5671 1.34212 12.5524 1.09171 12.5229C0.976091 12.5093 0.866391 12.5773 0.82714 12.6869C0.787888 12.7965 0.829476 12.9187 0.927437 12.9816C2.41947 13.9395 4.1946 14.4971 6.09501 14.4971C12.2884 14.4971 15.6834 9.35362 15.6834 4.91001V4.90722C15.6834 4.80742 15.6834 4.70772 15.6807 4.60512C16.3025 4.14082 16.8366 3.56597 17.2705 2.91517Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="0.5"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled58: {
      viewBox: '0 0 22 18',
      path: (
        <>
          <path
            d="M1.68359 3.793V14.1276C1.68359 14.6758 1.90136 15.2015 2.28898 15.5892C2.67661 15.9768 3.20234 16.1946 3.75052 16.1946H18.219C18.7672 16.1946 19.2929 15.9768 19.6805 15.5892C20.0682 15.2015 20.2859 14.6758 20.2859 14.1276V5.85992C20.2859 5.31174 20.0682 4.78601 19.6805 4.39839C19.2929 4.01076 18.7672 3.793 18.219 3.793H12.0182L9.95129 1.72607H3.75052C3.20234 1.72607 2.67661 1.94384 2.28898 2.33146C1.90136 2.71909 1.68359 3.24482 1.68359 3.793Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled59: {
      viewBox: '0 0 12 14',
      path: (
        <>
          <path
            d="M6.56883 7.05784C6.56883 5.02784 8.08883 3.37784 10.0488 3.12784C9.11883 2.29784 7.90883 1.78784 6.56883 1.78784C3.65883 1.78784 1.29883 4.14784 1.29883 7.05784C1.29883 9.96784 3.65883 12.3278 6.56883 12.3278C7.90883 12.3278 9.11883 11.8078 10.0488 10.9878C8.08883 10.7378 6.56883 9.08784 6.56883 7.05784Z"
            fill={props.svgFill ? props.svgFill : 'black'}
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    Filled60: {
      viewBox: '0 0 11 7',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.776808 1.0078C0.96411 0.820706 1.21811 0.715602 1.48296 0.715602C1.7478 0.715602 2.0018 0.820706 2.1891 1.0078L5.47813 4.29419L8.76716 1.0078C8.85929 0.912482 8.96951 0.836453 9.09136 0.784149C9.21322 0.731845 9.34428 0.704314 9.4769 0.703163C9.60952 0.702011 9.74104 0.727262 9.86379 0.777442C9.98654 0.827622 10.0981 0.901726 10.1918 0.99543C10.2856 1.08913 10.3598 1.20056 10.41 1.32321C10.4602 1.44586 10.4855 1.57728 10.4843 1.70979C10.4832 1.8423 10.4556 1.97326 10.4033 2.09502C10.3509 2.21678 10.2748 2.3269 10.1795 2.41896L6.18428 6.41093C5.99698 6.59802 5.74298 6.70312 5.47813 6.70312C5.21329 6.70312 4.95929 6.59802 4.77198 6.41093L0.776808 2.41896C0.589564 2.23181 0.484375 1.97801 0.484375 1.71338C0.484375 1.44875 0.589564 1.19495 0.776808 1.0078Z"
            stroke={props.stroke ? props.stroke : 'black'}
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    Filled61: {
      viewBox: '0 0 11 7',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2476 6.0088C10.0603 6.1959 9.8063 6.301 9.54146 6.301C9.27661 6.301 9.02261 6.1959 8.83531 6.0088L5.54628 2.72241L2.25725 6.0088C2.16512 6.10412 2.05491 6.18015 1.93305 6.23245C1.81119 6.28476 1.68013 6.31229 1.54751 6.31344C1.41489 6.31459 1.28337 6.28934 1.16062 6.23916C1.03788 6.18898 0.92636 6.11488 0.832581 6.02117C0.738801 5.92747 0.664638 5.81604 0.614417 5.69339C0.564197 5.57074 0.538925 5.43932 0.540077 5.30681C0.54123 5.1743 0.568783 5.04334 0.621128 4.92158C0.673474 4.79983 0.749565 4.6897 0.84496 4.59764L4.84014 0.605675C5.02744 0.41858 5.28144 0.313476 5.54628 0.313476C5.81113 0.313476 6.06513 0.41858 6.25243 0.605675L10.2476 4.59764C10.4349 4.78479 10.54 5.03859 10.54 5.30322C10.54 5.56785 10.4349 5.82165 10.2476 6.0088Z"
            stroke={props.stroke ? props.stroke : 'black'}
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    writerlyLeftArrow: {
      viewBox: '0 0 13 11',
      path: (
        <>
          <path
            d="M5.25684 1.06445L1.70697 4.61432C1.31645 5.00484 1.31645 5.63801 1.70697 6.02853L5.25684 9.5784"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <line
            x1="1.1709"
            y1="5.33398"
            x2="12.058"
            y2="5.33398"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    writerlyLockQuestion: {
      viewBox: '0 0 87 96',
      path: (
        <>
          <rect
            x="2.87879"
            y="28.9432"
            width="60.4545"
            height="40.303"
            rx="5.75758"
            fill="url(#paint0_linear_844_41608)"
            stroke="white"
            strokeWidth="5.75758"
          />
          <path
            d="M14.3939 8.79163C14.3939 5.61181 16.9717 3.03406 20.1515 3.03406H46.0606C49.2404 3.03406 51.8182 5.61182 51.8182 8.79164V28.9431H14.3939V8.79163Z"
            stroke="white"
            strokeWidth="5.75758"
          />
          <circle cx="23.5103" cy="49.0946" r="2.87879" fill="white" />
          <circle cx="33.1064" cy="49.0946" r="2.87879" fill="white" />
          <circle cx="42.7021" cy="49.0946" r="2.87879" fill="white" />
          <circle cx="63.3334" cy="72.125" r="20.1515" fill="#4EE197" />
          <circle
            cx="63.3334"
            cy="72.125"
            r="20.1515"
            fill="url(#paint1_linear_844_41608)"
          />
          <circle
            cx="63.3334"
            cy="72.125"
            r="20.1515"
            stroke="white"
            strokeWidth="5.75758"
          />
          <circle cx="63.7878" cy="82.6856" r="2.60605" fill="white" />
          <path
            d="M58.5758 66.3044C58.5758 64.8153 59.6182 61.8369 63.7879 61.8369C67.9576 61.8369 69 64.8153 69 66.3044C69 67.1705 68.6474 68.5907 67.5321 69.7446C65.8497 71.4854 63.7879 73.3147 63.7879 75.7356V77.4732"
            stroke="white"
            strokeWidth="3.90907"
          />
          <defs>
            <linearGradient
              id="paint0_linear_844_41608"
              x1="50.5"
              y1="35.6555"
              x2="13.5"
              y2="66.1555"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#43B9A1" />
              <stop offset="1" stopColor="#4FE09A" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_844_41608"
              x1="77.5"
              y1="81.1555"
              x2="55"
              y2="85.1555"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#43B9A1" />
              <stop offset="1" stopColor="#4FDF9A" />
            </linearGradient>
          </defs>
        </>
      ),
    },
    writerlyMessageCheck: {
      viewBox: '0 0 88 92',
      path: (
        <>
          <rect
            x="3.67054"
            y="25.0004"
            width="60.4545"
            height="40.303"
            rx="5.75758"
            fill="url(#paint0_linear_844_41677)"
            stroke="white"
            strokeWidth="5.75758"
          />
          <circle cx="64.125" cy="68.1822" r="20.1515" fill="#4EE197" />
          <circle
            cx="64.125"
            cy="68.1822"
            r="20.1515"
            fill="url(#paint1_linear_844_41677)"
          />
          <circle
            cx="64.125"
            cy="68.1822"
            r="20.1515"
            stroke="white"
            strokeWidth="5.75758"
          />
          <path
            d="M58.884 24.7124L39.4011 44.1953C36.027 47.5694 30.5565 47.5694 27.1823 44.1953L8.79175 25.8047"
            stroke="white"
            strokeWidth="5.76"
          />
          <path
            d="M55.7917 68.2124L61.0559 73.0379C61.4625 73.4106 62.0941 73.3837 62.4676 72.9778L73.2917 61.2124"
            stroke="white"
            strokeWidth="3.91"
          />
          <defs>
            <linearGradient
              id="paint0_linear_844_41677"
              x1="51.2917"
              y1="31.7126"
              x2="14.2917"
              y2="62.2126"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#43B9A1" />
              <stop offset="1" stopColor="#4FE09A" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_844_41677"
              x1="78.2916"
              y1="77.2126"
              x2="55.7916"
              y2="81.2126"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#43B9A1" />
              <stop offset="1" stopColor="#4FDF9A" />
            </linearGradient>
          </defs>
        </>
      ),
    },
    writerlyPen: {
      viewBox: '0 0 26 25',
      path: (
        <>
          <path
            d="M5.22636 24.0002H1.79199V20.5529L15.13 7.21487L18.577 10.6618L5.22636 24.0002ZM21.3786 7.86073L17.9314 4.41349L20.6743 1.67028C20.7894 1.55522 20.9729 1.55522 21.088 1.67028L24.1215 4.70383L24.8004 4.02501L24.1215 4.70383C24.2366 4.8189 24.2366 5.00246 24.1215 5.11753L24.1215 5.11756L21.3786 7.86073Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    writerlyCheckBox: {
      viewBox: '0 0 20 19',
      path: (
        <>
          <rect
            x="0.587402"
            width="18.5443"
            height="19"
            rx="5"
            stroke={props.stroke ? props.stroke : 'black'}
            fill={props.svgFill ? props.svgFill : 'black'}
          />
        </>
      ),
    },
    writerlySend: {
      viewBox: '0 0 17 15',
      path: (
        <>
          <path
            d="M14.9375 6.72244L3.08118 1.18937C2.2551 0.803859 1.38615 1.63436 1.7339 2.47703L3.38799 6.48515C3.54247 6.85947 3.90743 7.10367 4.31237 7.10367H14.8529C15.0669 7.10367 15.1314 6.81293 14.9375 6.72244Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M15.183 7.48475L3.08118 13.1324C2.2551 13.5179 1.38615 12.6874 1.7339 11.8448L3.43528 7.72204C3.58976 7.34772 3.95472 7.10352 4.35966 7.10352H15.0984C15.3124 7.10352 15.3769 7.39426 15.183 7.48475Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
        </>
      ),
    },
    instagram: {
      viewBox: '0 0 16 16',
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.73081 2.74961C3.33468 2.14574 4.1537 1.80649 5.0077 1.80649H11.1677C12.0217 1.80649 12.8407 2.14574 13.4446 2.74961C14.0484 3.35347 14.3877 4.17249 14.3877 5.02649V11.1865C14.3877 12.0405 14.0484 12.8595 13.4446 13.4634C12.8407 14.0672 12.0217 14.4065 11.1677 14.4065H5.0077C4.1537 14.4065 3.33468 14.0672 2.73081 13.4634C2.12695 12.8595 1.7877 12.0405 1.7877 11.1865V5.02649C1.7877 4.17249 2.12695 3.35347 2.73081 2.74961ZM5.0077 0.406491C3.7824 0.406491 2.60728 0.89324 1.74086 1.75966C0.874445 2.62608 0.387695 3.80119 0.387695 5.02649V11.1865C0.387695 12.4118 0.874445 13.5869 1.74086 14.4533C2.60728 15.3197 3.7824 15.8065 5.0077 15.8065H11.1677C12.393 15.8065 13.5681 15.3197 14.4345 14.4533C15.3009 13.5869 15.7877 12.4118 15.7877 11.1865V5.02649C15.7877 3.80119 15.3009 2.62608 14.4345 1.75966C13.5681 0.89324 12.393 0.406491 11.1677 0.406491H5.0077ZM7.23212 6.82603C7.48506 6.65701 7.7824 6.56671 8.0866 6.56649C8.49483 6.56805 8.88592 6.7309 9.1746 7.01959C9.46326 7.30825 9.62611 7.69929 9.6277 8.10748C9.6275 8.41172 9.53719 8.70909 9.36816 8.96207C9.19894 9.21532 8.95843 9.41271 8.67703 9.52927C8.39563 9.64583 8.08599 9.67632 7.78726 9.6169C7.48853 9.55748 7.21413 9.41081 6.99875 9.19544C6.78338 8.98006 6.63671 8.70566 6.57729 8.40693C6.51787 8.1082 6.54836 7.79856 6.66492 7.51716C6.78148 7.23576 6.97887 6.99525 7.23212 6.82603ZM8.0877 5.16649C7.50622 5.16649 6.9378 5.33892 6.45432 5.66197C5.97084 5.98502 5.59401 6.44419 5.37149 6.9814C5.14897 7.51862 5.09075 8.10975 5.20419 8.68006C5.31763 9.25036 5.59764 9.77422 6.0088 10.1854C6.41997 10.5966 6.94383 10.8766 7.51413 10.99C8.08443 11.1034 8.67557 11.0452 9.21278 10.8227C9.75 10.6002 10.2092 10.2233 10.5322 9.73987C10.8553 9.25639 11.0277 8.68797 11.0277 8.10649L11.0277 8.10431C11.0253 7.3259 10.715 6.58006 10.1646 6.02964C9.61413 5.47921 8.86829 5.16892 8.08987 5.16649H8.0877ZM11.5877 5.48149C12.0709 5.48149 12.4627 5.08974 12.4627 4.60649C12.4627 4.12324 12.0709 3.73149 11.5877 3.73149C11.1044 3.73149 10.7127 4.12324 10.7127 4.60649C10.7127 5.08974 11.1044 5.48149 11.5877 5.48149Z"
          fill={props.stroke ? props.stroke : 'black'}
          strokeWidth="0.01"
        />
      ),
    },
    writerlyCamera: {
      viewBox: '0 0 21 17',
      path: (
        <>
          <path
            d="M14.6053 3.1138L12.5384 1.04688H8.3664L6.29948 3.1138H3.439C2.89081 3.1138 2.36508 3.33156 1.97746 3.71919C1.58984 4.10681 1.37207 4.63254 1.37207 5.18073V13.4484C1.37207 13.9966 1.58984 14.5223 1.97746 14.91C2.36508 15.2976 2.89081 15.5154 3.439 15.5154H17.4658C18.014 15.5154 18.5397 15.2976 18.9273 14.91C19.315 14.5223 19.5327 13.9966 19.5327 13.4484V5.18073C19.5327 4.63254 19.315 4.10681 18.9273 3.71919C18.5397 3.33156 18.014 3.1138 17.4658 3.1138H14.6053Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="10.4526"
            cy="9.00781"
            r="2.81588"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
          />
        </>
      ),
    },
    writerlyBug: {
      viewBox: '0 0 20 19',
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1578 2.67969C11.1394 2.67969 11.9847 3.2634 12.3654 4.10265H7.95019C8.33095 3.2634 9.17622 2.67969 10.1578 2.67969ZM14.5296 4.42766H15.3857C15.938 4.42766 16.3857 4.87538 16.3857 5.42766V5.4538V5.45386C16.3857 5.85799 16.3857 6.3911 16.3707 7.00957L17.9507 6.09736C18.429 5.82121 19.0406 5.98509 19.3168 6.46338C19.5929 6.94167 19.429 7.55327 18.9507 7.82941L16.5654 9.2066C16.463 9.26569 16.3546 9.30462 16.2446 9.32465C16.2148 9.66066 16.1787 10.004 16.135 10.3508H18.4536C19.0059 10.3508 19.4536 10.7985 19.4536 11.3508C19.4536 11.9031 19.0059 12.3508 18.4536 12.3508H15.7915C15.7633 12.4767 15.7337 12.602 15.7026 12.7266C15.6181 13.0664 15.5218 13.4066 15.4117 13.7421C15.4234 13.7482 15.4349 13.7546 15.4464 13.7612L17.8318 15.1384C18.31 15.4146 18.4739 16.0262 18.1978 16.5044C17.9216 16.9827 17.31 17.1466 16.8317 16.8705L14.6105 15.588C14.4155 15.93 14.1973 16.2534 13.9528 16.551C13.054 17.6448 11.8031 18.3772 10.1577 18.3772C8.51229 18.3772 7.26139 17.6448 6.36262 16.551C6.11873 16.2542 5.90102 15.9316 5.70642 15.5907L3.48304 16.8743C3.00475 17.1505 2.39316 16.9866 2.11702 16.5083C1.84088 16.03 2.00475 15.4184 2.48304 15.1423L4.86841 13.7651C4.88041 13.7582 4.89249 13.7515 4.90464 13.7451C4.79414 13.4086 4.69755 13.0675 4.61275 12.7266C4.58174 12.602 4.55213 12.4767 4.52387 12.3508H1.86133C1.30904 12.3508 0.861328 11.9031 0.861328 11.3508C0.861328 10.7985 1.30904 10.3508 1.86133 10.3508H4.18038C4.1365 10.0027 4.10029 9.65806 4.07043 9.32085C3.96038 9.30083 3.85185 9.26188 3.74943 9.20275L1.36406 7.82556C0.88577 7.54941 0.721895 6.93782 0.998038 6.45953C1.27418 5.98124 1.88577 5.81736 2.36406 6.09351L3.94457 7.00601C3.92964 6.38904 3.92965 5.85719 3.92966 5.45383V5.45382V5.45382V5.45381V5.42767C3.92965 4.87538 4.37737 4.42767 4.92966 4.42767H5.78603C6.11102 2.30531 7.94458 0.679688 10.1578 0.679688C12.3711 0.679688 14.2046 2.30531 14.5296 4.42766ZM5.93467 6.42767L14.3807 6.42766C14.3607 7.98881 14.2606 10.2389 13.7618 12.2437C13.4517 13.4902 13.0082 14.5502 12.4075 15.2812C11.8359 15.9769 11.1263 16.3772 10.1577 16.3772C9.18908 16.3772 8.47946 15.9769 7.90785 15.2812C7.30714 14.5502 6.86371 13.4902 6.55357 12.2437C6.05474 10.2389 5.95471 7.98881 5.93467 6.42767Z"
          fill={props.stroke ? props.stroke : 'black'}
          strokeWidth="0.01"
        />
      ),
    },
    writerlyEmpty: {
      viewBox: '0 0 61 57',
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.62874 4.20815H56.4739C56.5638 4.20815 56.6366 4.28103 56.6366 4.37093V51.9838C56.6366 52.0737 56.5638 52.1466 56.4739 52.1466H4.62874C4.53884 52.1466 4.46596 52.0737 4.46596 51.9838V4.37093C4.46596 4.28103 4.53884 4.20815 4.62874 4.20815ZM56.4739 0.138672H4.62874C2.29133 0.138672 0.396484 2.03352 0.396484 4.37093V51.9838C0.396484 54.3212 2.29133 56.216 4.62874 56.216H56.4739C58.8113 56.216 60.7061 54.3212 60.7061 51.9838V4.37093C60.7061 2.03352 58.8113 0.138672 56.4739 0.138672ZM18.6669 41.9829H20.4607L36.7865 25.6721L34.9766 23.8622L18.6669 40.1719V41.9829ZM21.5353 45.4419C21.7677 45.4419 22 45.3526 22.1609 45.1738L41.6783 25.6743L41.6794 25.6732L34.9766 18.9704L15.476 38.471C15.2972 38.6498 15.2079 38.8643 15.2079 39.1145V44.5482C15.2079 45.0487 15.6011 45.4419 16.1016 45.4419H21.5353ZM43.5919 23.7606L36.8892 17.0579L41.6459 12.3007C42.343 11.6036 43.469 11.6036 44.1661 12.3007L48.3487 16.4832C49.0458 17.1803 49.0458 18.3064 48.3487 19.0034L43.5919 23.7606ZM44.717 17.7434L43.5918 18.8687L41.7809 17.0577L42.9061 15.9324L44.717 17.7434ZM22.2861 11.7764C23.1778 11.7764 23.9006 12.4992 23.9006 13.3909V16.2883H26.8477C27.7394 16.2883 28.4622 17.0112 28.4622 17.9029C28.4622 18.7946 27.7394 19.5174 26.8477 19.5174H23.9006V22.3584C23.9006 23.2501 23.1778 23.973 22.2861 23.973C21.3944 23.973 20.6715 23.2501 20.6715 22.3584V19.5174H17.8802C16.9885 19.5174 16.2656 18.7946 16.2656 17.9029C16.2656 17.0112 16.9885 16.2883 17.8802 16.2883H20.6715V13.3909C20.6715 12.4992 21.3944 11.7764 22.2861 11.7764Z"
          fill={props.stroke ? props.stroke : '#7A818C'}
          strokeWidth={props.strokeWidth ? props.strokeWidth : '0.01'}
        />
      ),
    },
    writerlyLogout: {
      viewBox: '0 0 23 19',
      path: (
        <>
          <path
            d="M8.19117 8.27785C10.1186 8.27785 11.6812 6.71533 11.6812 4.78785C11.6812 2.86038 10.1186 1.29785 8.19117 1.29785C6.2637 1.29785 4.70117 2.86038 4.70117 4.78785C4.70117 6.71533 6.2637 8.27785 8.19117 8.27785Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.78094 10.0679C2.79094 11.2379 1.46094 13.3979 1.46094 15.8679C5.51094 18.6679 10.8709 18.6679 14.9209 15.8679C14.9209 13.3979 13.5909 11.2379 11.6009 10.0679"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.4446 8.60449L15.5898 8.60449"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.627 4.7876L23.4434 8.60405L19.627 12.4205"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    writerlyMobileMenu: {
      viewBox: '0 0 10 11',
      path: (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.33153 2.67529L0.03125 2.67529V0.675293H9.33153V2.67529ZM9.33153 6.69971L0.03125 6.69971V4.69971L9.33153 4.69971V6.69971ZM0.03125 10.7241L9.33153 10.7241V8.72412L0.03125 8.72412V10.7241Z"
          fill={props.stroke ? props.stroke : '#7A818C'}
        />
      ),
    },
    writerlyOpenEyeIcon: {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M11.9988 6.50098C8.77396 6.44557 5.43872 8.74101 3.34189 11.0918C3.1218 11.3407 3 11.6638 3 11.9988C3 12.3337 3.1218 12.6568 3.34189 12.9057C5.39312 15.2068 8.71876 17.5552 11.9988 17.499C15.2788 17.5552 18.6053 15.2068 20.6581 12.9057C20.8782 12.6568 21 12.3337 21 11.9988C21 11.6638 20.8782 11.3407 20.6581 11.0918C18.5589 8.74101 15.2236 6.44557 11.9988 6.50098Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeOpacity="0.76"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.0001 12.0008C14.9999 12.6052 14.8238 13.1959 14.4941 13.6983C14.1643 14.2007 13.6957 14.5922 13.1475 14.8233C12.5993 15.0545 11.9962 15.1149 11.4143 14.9969C10.8324 14.8789 10.2979 14.5878 9.87841 14.1604C9.45893 13.7331 9.17328 13.1886 9.05759 12.5959C8.9419 12.0031 9.00135 11.3888 9.22844 10.8305C9.45553 10.2722 9.84005 9.79498 10.3334 9.45926C10.8267 9.12353 11.4067 8.94434 12 8.94434C12.3941 8.94423 12.7843 9.02322 13.1484 9.1768C13.5125 9.33037 13.8433 9.55552 14.1219 9.83938C14.4005 10.1232 14.6215 10.4602 14.7722 10.8311C14.9228 11.202 15.0003 11.5995 15.0001 12.0008Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeOpacity="0.76"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    writerlyClosedEyeIcon: {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M4.625 19L19.6261 5"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeOpacity="0.76"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.60156 17.4832C10.3784 17.719 11.1879 17.837 12.0017 17.8332C15.282 17.8877 18.6102 15.6477 20.6584 13.4466C20.8793 13.2103 21.0017 12.9025 21.0017 12.5832C21.0017 12.264 20.8793 11.9561 20.6584 11.7199C19.9178 10.9241 19.0947 10.2048 18.2022 9.57324"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeOpacity="0.76"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.0723 8.3208C14.8133 7.68581 13.4183 7.34745 12 7.33302C8.79977 7.27858 5.43952 9.47191 3.34337 11.7197C3.12243 11.9559 3 12.2637 3 12.583C3 12.9023 3.12243 13.2101 3.34337 13.4464C4.47936 14.6809 5.81089 15.7312 7.28766 16.5575"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeOpacity="0.76"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.60102 14.388C9.16701 13.8027 8.96501 13.0846 9.03218 12.366C9.09935 11.6474 9.43117 10.9766 9.96661 10.4769C10.502 9.97717 11.2051 9.68222 11.9464 9.64629C12.6877 9.61037 13.4174 9.83587 14.0013 10.2813"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeOpacity="0.76"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.0002 12.583C15.0002 12.966 14.9226 13.3453 14.7718 13.6992C14.6211 14.053 14.4001 14.3746 14.1215 14.6454C13.8429 14.9162 13.5121 15.1311 13.1481 15.2777C12.7841 15.4242 12.394 15.4997 12 15.4997"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeOpacity="0.76"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    writerlyAvalancheModeIcon: {
      viewBox: '0 0 23 17',
      path: (
        <>
          <path
            d="M8.97467 1.82227L16.7345 15.2545H1.21484L8.97467 1.82227Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.26465 7.14111L8.97454 9.85045L11.6839 7.14111"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="2"
          />
          <path
            d="M18.7589 8.69316C19.7087 8.14479 20.9232 8.47022 21.4715 9.42001C21.9553 10.2579 21.8801 11.2107 21.144 11.9695C20.9405 12.1793 20.6718 12.309 20.3942 12.4006L20.2643 12.4434C19.7837 12.6018 19.2632 12.5911 18.7895 12.4128V12.4128C18.3081 12.2317 17.9047 11.8888 17.6483 11.4429L13.3549 3.9758"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ),
    },
    writerlyCreateCustomTemplateIcon: {
      viewBox: '0 0 24 21',
      path: (
        <>
          <path
            d="M11.3477 12.3839L11.3477 16.3855C11.3477 17.0032 10.7862 17.5039 10.0936 17.5039L3.20687 17.5039C2.51425 17.5039 1.95277 17.0032 1.95277 16.3855L1.95277 12.3839C1.95277 11.7662 2.51425 11.2655 3.20687 11.2655L10.0936 11.2655C10.7862 11.2655 11.3477 11.7662 11.3477 12.3839Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeMiterlimit="10"
          />
          <path
            d="M1.95313 6.59266L1.95313 2.59104C1.95313 1.97337 2.5146 1.47266 3.20723 1.47266L6.3606 1.47266C7.05322 1.47266 7.6147 1.97337 7.6147 2.59104L7.6147 6.59266C7.6147 7.21032 7.05322 7.71104 6.3606 7.71104L3.20723 7.71104C2.51461 7.71104 1.95313 7.21032 1.95313 6.59266Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeMiterlimit="10"
          />
          <path
            d="M11.4707 6.59266L11.4707 2.59104C11.4707 1.97337 12.0322 1.47266 12.7248 1.47266L19.6115 1.47266C20.3041 1.47266 20.8656 1.97337 20.8656 2.59104L20.8656 6.59265C20.8656 7.21032 20.3041 7.71104 19.6115 7.71104L12.7248 7.71104C12.0322 7.71104 11.4707 7.21032 11.4707 6.59266Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeMiterlimit="10"
          />
          <line
            x1="19.2587"
            y1="19.1259"
            x2="19.2587"
            y2="11.9586"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
          />
          <line
            x1="15.7266"
            y1="15.4931"
            x2="22.8939"
            y2="15.4931"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeLinecap="round"
          />
        </>
      ),
    },
    writerlyClearIcon: {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M11.1259 21.7573L2.00426 12.6356L7.1025 8.66875C7.80961 8.1172 8.82784 8.17377 9.47131 8.81724L14.9443 14.2902C15.5807 14.9266 15.6443 15.9378 15.0928 16.6591L11.1259 21.7573Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M6.28223 9.77162L14.2725 17.7619"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M19.0021 4.36265C19.4547 4.8152 19.305 5.71444 18.6494 6.37003L12.9004 12.119L11.2457 10.4644L16.9947 4.7154C17.6402 4.0699 18.5425 3.90303 19.0021 4.36265Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.8"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M4.98637 15.6255L6.64453 13.9674"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
          <path
            d="M7.49955 18.1388L9.15771 16.4808"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="square"
          />
        </>
      ),
    },
    writerlyTemplates: {
      viewBox: '0 0 20 17',
      path: (
        <>
          <path
            d="M18.5879 6.13248L18.5879 2.51704C18.5879 1.95899 18.0806 1.50659 17.4548 1.50659L14.6058 1.50659C13.98 1.50659 13.4727 1.95899 13.4727 2.51704L13.4727 6.13248C13.4727 6.69053 13.98 7.14293 14.6058 7.14293L17.4548 7.14293C18.0806 7.14293 18.5879 6.69053 18.5879 6.13248Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeMiterlimit="10"
          />
          <path
            d="M9.98828 6.13248L9.98828 2.51704C9.98828 1.95899 9.48099 1.50659 8.85521 1.50659L2.63314 1.50659C2.00736 1.50659 1.50006 1.95899 1.50006 2.51704L1.50006 6.13248C1.50006 6.69053 2.00736 7.14293 2.63314 7.14293L8.85521 7.14293C9.48099 7.14293 9.98828 6.69053 9.98828 6.13248Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeMiterlimit="10"
          />
          <path
            d="M1.5 11.3648L1.5 14.9803C1.5 15.5383 2.00729 15.9907 2.63307 15.9907L5.48213 15.9907C6.1079 15.9907 6.6152 15.5383 6.6152 14.9803L6.6152 11.3648C6.6152 10.8068 6.1079 10.3544 5.48213 10.3544L2.63307 10.3544C2.00729 10.3544 1.5 10.8068 1.5 11.3648Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeMiterlimit="10"
          />
          <path
            d="M10.0986 11.3648L10.0986 14.9803C10.0986 15.5383 10.6059 15.9907 11.2317 15.9907L17.4538 15.9907C18.0796 15.9907 18.5868 15.5383 18.5868 14.9803L18.5868 11.3648C18.5868 10.8068 18.0796 10.3544 17.4538 10.3544L11.2317 10.3544C10.6059 10.3544 10.0986 10.8068 10.0986 11.3648Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.92"
            strokeMiterlimit="10"
          />
        </>
      ),
    },
    writerlyBulkJob: {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M13.3578 11.5998C14.6414 12.094 16.0872 11.4951 16.6454 10.238C16.8687 9.73506 17.5825 9.73506 17.8058 10.238C18.364 11.4951 19.8097 12.094 21.0934 11.5998C21.6069 11.402 22.1116 11.9067 21.9139 12.4203C21.4197 13.7039 22.0185 15.1497 23.2757 15.7079C23.7786 15.9312 23.7786 16.645 23.2757 16.8683C22.0185 17.4265 21.4197 18.8722 21.9139 20.1559C22.1116 20.6694 21.6069 21.1741 21.0934 20.9764C19.8097 20.4822 18.364 21.081 17.8058 22.3382C17.5825 22.8411 16.8687 22.8411 16.6454 22.3382C16.0872 21.081 14.6414 20.4822 13.3578 20.9764C12.8442 21.1741 12.3395 20.6694 12.5373 20.1559C13.0315 18.8722 12.4326 17.4265 11.1755 16.8683C10.6726 16.645 10.6726 15.9312 11.1755 15.7079C12.4326 15.1497 13.0315 13.7039 12.5373 12.4203C12.3395 11.9067 12.8442 11.402 13.3578 11.5998Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.94723"
          />
          <circle
            cx="17.2259"
            cy="16.2884"
            r="1.61358"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.94723"
          />
          <path
            d="M17.2261 6.24741V1.48193H1.15527V20.5438H9.19067"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.0425 4.8916H3.58008V7.37753H6.0425V4.8916Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="square"
          />
          <path
            d="M6.0425 9.76953H3.58008V12.2555H6.0425V9.76953Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="square"
          />
          <path
            d="M6.0425 14.6475H3.58008V17.1334H6.0425V14.6475Z"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="square"
          />
          <path
            d="M8.68945 7.0127H14.6895"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="square"
          />
          <path
            d="M8.68945 12.0127H10.1289"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="square"
          />
          <path
            d="M8.68945 17.0127L8.68945 17.1333"
            stroke={props.stroke ? props.stroke : 'black'}
            strokeWidth="1.4"
            strokeLinecap="square"
          />
        </>
      ),
    },
    coffeeCup: {
      viewBox: '0 0 62 74',
      path: (
        <>
          <path
            d="M28.8526 10.5272C28.4186 11.1121 28.5324 11.9441 29.1067 12.3858C30.8905 13.7576 30.444 14.8703 28.7134 17.6998C27.2472 20.0971 25.2393 23.3803 28.1905 26.5816C28.4468 26.8597 28.7933 27 29.1406 27C29.46 27 29.7805 26.8811 30.0318 26.6405C30.5565 26.1389 30.5825 25.2992 30.09 24.7652C28.6599 23.2134 29.2463 21.8485 30.9251 19.1029C32.4424 16.622 34.5203 13.2244 30.6771 10.268C30.1028 9.82638 29.2859 9.9427 28.8526 10.5272Z"
            fill={props.stroke ? props.stroke : 'black'}
          />
          <path
            d="M34.1444 15.5626C34.3803 15.8531 34.6994 16 35.0188 16C35.3132 16 35.6083 15.8755 35.8396 15.6245C36.3226 15.1006 36.3466 14.2235 35.8931 13.6654C34.7927 12.3112 35.2347 11.1536 36.5888 8.64171C37.7792 6.43319 39.5785 3.09555 36.3528 0.279956C35.8241 -0.181338 35.072 -0.0598446 34.6728 0.550657C34.2736 1.16154 34.3784 2.03059 34.9067 2.49189C36.2096 3.6286 36.0151 4.46311 34.5525 7.1762C33.3368 9.43141 31.6718 12.52 34.1444 15.5626Z"
            fill={props.stroke ? props.stroke : 'black'}
          />
          <path
            d="M26.1879 15.5739C26.4203 15.8569 26.7337 16 27.0481 16C27.3377 16 27.6276 15.8787 27.8554 15.6342C28.3304 15.1238 28.3537 14.2695 27.9077 13.7258C26.7728 12.3422 27.2239 11.1679 28.6093 8.62258C29.8108 6.41531 31.6259 3.07963 28.3792 0.272829C27.8593 -0.17654 27.1196 -0.0585577 26.7269 0.536533C26.3343 1.13125 26.4374 1.97784 26.9573 2.42758C28.3039 3.5915 28.1061 4.43994 26.6067 7.19496C25.3794 9.45031 23.6984 12.5389 26.1879 15.5739Z"
            fill={props.stroke ? props.stroke : 'black'}
          />
          <mask
            id="mask0_0_9"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="23"
            width="62"
            height="51"
          >
            <path
              d="M0.842529 23.0142H61.1025V73.915H0.842529V23.0142Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_0_9)">
            <path
              d="M52.6018 29.2088C52.5693 28.9956 52.5352 28.7825 52.4995 28.5701C52.373 26.446 49.747 25.4258 47.4513 24.7733C44.7306 23.9999 41.0001 23.424 36.6624 23.1077C35.995 23.0623 35.4216 23.6318 35.3789 24.3864C35.3358 25.1414 35.8411 25.7927 36.5072 25.8415C44.9627 26.458 48.9431 27.9188 49.9241 28.7221C49.4447 29.1097 47.9592 29.9727 43.7003 30.7483C39.6894 31.4789 34.5029 31.8811 29.0958 31.8811C23.6891 31.8811 18.5026 31.4789 14.4917 30.7483C10.2318 29.9727 8.74665 29.1093 8.26759 28.7221C9.25584 27.9105 13.2873 26.437 21.8623 25.8288C22.5284 25.7815 23.0346 25.1309 22.9929 24.3759C22.9512 23.621 22.3784 23.0472 21.7113 23.0945C17.3283 23.4056 13.5544 23.9804 10.798 24.7571C7.2628 25.753 5.68624 26.9788 5.68624 28.7307C5.68624 28.8129 5.69121 28.8932 5.69816 28.9731C5.37073 31.0492 5.20288 33.1764 5.20288 35.3054C5.20288 44.1873 8.05869 52.2152 12.6354 57.9069C7.00655 59.063 0.852295 61.2276 0.852295 65.1641C0.852295 67.913 3.83093 70.1204 9.70642 71.7256C14.9092 73.1473 21.8077 73.93 29.1313 73.93C36.4545 73.93 43.353 73.1473 48.5561 71.7256C54.4313 70.1204 57.4102 67.913 57.4102 65.1641C57.4102 61.2378 51.3053 59.072 45.6272 57.9069C46.5015 56.8195 47.312 55.6455 48.0529 54.3978C48.6197 54.4935 49.1861 54.5423 49.7493 54.5423C52.139 54.5423 54.4604 53.6887 56.4266 52.0602C58.8769 50.0314 60.4832 47.0427 60.9497 43.6443C61.8532 37.0656 58.1691 30.8556 52.6018 29.2088ZM7.80608 31.5693C9.02972 32.2327 10.8029 32.7903 13.1836 33.2751C17.4452 34.1426 23.0962 34.6206 29.0958 34.6206C35.0955 34.6206 40.7469 34.1426 45.0084 33.2751C47.4318 32.7816 49.2272 32.2128 50.4528 31.5333C50.578 32.782 50.6425 34.0431 50.6425 35.3054C50.6425 51.0145 40.9925 63.7945 29.1313 63.7945C17.2697 63.7945 7.61969 51.0145 7.61969 35.3054C7.61969 34.0551 7.68326 32.806 7.80608 31.5693ZM54.9931 65.1641C54.9931 65.7164 53.735 67.4931 47.9897 69.0627C42.9667 70.4352 36.2695 71.1909 29.1313 71.1909C21.9931 71.1909 15.2955 70.4352 10.2726 69.0627C4.5275 67.4931 3.2691 65.7164 3.2691 65.1641C3.2691 64.4467 5.27539 62.0284 14.1901 60.383C14.3676 60.3504 14.5278 60.2727 14.6678 60.1658C18.688 64.1593 23.7007 66.534 29.1313 66.534C34.5297 66.534 39.5156 64.1878 43.5235 60.237C43.6136 60.2806 43.7076 60.317 43.8089 60.335C51.9569 61.8006 54.9931 64.0752 54.9931 65.1641ZM58.5617 43.2233C57.8754 48.2202 54.0602 51.8017 49.7304 51.8009C49.6348 51.8009 49.5387 51.7983 49.4427 51.7949C51.7334 47.006 53.0597 41.3544 53.0597 35.3054C53.0597 34.2705 53.0183 33.2364 52.9401 32.2079C56.7825 33.8852 59.2199 38.4287 58.5617 43.2233Z"
              fill={props.stroke ? props.stroke : 'black'}
            />
          </g>
          <path
            d="M26.3656 61C27.0238 61 27.5573 60.3987 27.5573 59.6567C27.5573 58.9148 27.0238 58.3131 26.3656 58.3131C21.938 58.3131 15.8293 51.6964 14.8675 47.0391C14.7183 46.3163 14.0768 45.8673 13.4369 46.0352C12.7957 46.2033 12.397 46.9258 12.5462 47.6482C13.9661 54.525 21.5354 61 26.3656 61Z"
            fill={props.stroke ? props.stroke : 'black'}
          />
        </>
      ),
    },
  };
};
